import type { Translations } from './types';

export const it: Translations = {
  // Common
  'common.loading': 'Caricamento…',
  'common.prev': 'Prec.',
  'common.next': 'Succ.',
  'common.cancel': 'Annulla',
  'common.back': 'Indietro',
  'common.search': 'Cerca',
  'common.close': 'Chiudi',
  'common.exit': 'Esci',
  'common.noData': 'Nessun dato',
  'common.failedToLoad': 'Caricamento non riuscito',
  'common.retry': 'Riprova',
  'common.reloadPage': 'Ricarica pagina',
  'common.beta': 'Beta',

  // Auth
  'auth.subtitle': 'Piattaforma di Telemetria Karting',
  'auth.signInDescription': 'Accedi per visualizzare i dati di telemetria.',
  'auth.signInWithGoogle': 'Accedi con Google',
  'auth.signInWithApple': 'Accedi con Apple',
  'auth.or': 'oppure',
  'auth.signingIn': 'Accesso in corso…',
  'auth.signOut': 'Esci',

  // OAuth Consent
  'oauth.authorizeTitle': 'Autorizza {name}',
  'oauth.authorizeSubtitle': '{name} richiede l\'accesso al tuo account di telemetria kart.win.',
  'oauth.permissionsTitle': 'Autorizzazioni richieste',
  'oauth.permSessions': 'Lettura di tutte le sessioni, dei giri e dei canali di telemetria',
  'oauth.permAnalysis': 'Lettura delle metriche calcolate e dei confronti',
  'oauth.permSetups': 'Lettura dei setup del kart e delle configurazioni dei tracciati',
  'oauth.signedIn': 'Accesso effettuato',
  'oauth.mustSignInFirst': 'Effettua l\'accesso per autorizzare questa applicazione',
  'oauth.authorizeButton': 'Autorizza applicazione',
  'oauth.missingParams': 'Parametri di autorizzazione OAuth obbligatori mancanti',

  // Settings
  'settings.title': 'Impostazioni',
  'settings.account': 'Account',
  'settings.profile': 'Profilo',
  'settings.displayName': 'Nome visualizzato',
  'settings.saveName': 'Salva nome',
  'settings.nameSaved': 'Nome aggiornato correttamente',
  'settings.linkedAccounts': 'Account collegati',
  'settings.linkGoogle': 'Collega account Google',
  'settings.linkApple': 'Collega account Apple',
  'settings.unlink': 'Scollega',
  'settings.linked': 'Collegato',
  'settings.notLinked': 'Non collegato',
  'settings.cannotUnlinkOnlyProvider': 'Deve rimanere collegato almeno un metodo di accesso.',
  'settings.language': 'Lingua',
  'settings.userId': 'ID utente',
  'settings.signOut': 'Esci',
  'settings.connectedApps': 'Applicazioni connesse',
  'settings.connectedAppsDesc': 'Gestisci assistenti IA, IDE e strumenti autorizzati ad accedere ai tuoi dati di telemetria tramite MCP.',
  'settings.noConnectedApps': 'Nessuna applicazione connessa. Autorizza un client MCP (come Claude Desktop o Cursor) per vederlo qui.',
  'settings.authorizedOn': 'Autorizzato il',
  'settings.lastUsed': 'Ultimo utilizzo',
  'settings.neverUsed': 'Mai',
  'settings.revoke': 'Revoca',
  'settings.revokeAppConfirm': 'Sei sicuro di voler revocare l\'accesso per questa applicazione? Tutte le sessioni attive smetteranno immediatamente di funzionare.',
  'settings.appRevokedSuccess': 'Accesso all\'applicazione revocato correttamente',
  'settings.copyKey': 'Copia snippet',
  'settings.keyCopied': 'Copiato negli appunti',
  'settings.mcpConfigSnippet': 'Configurazione client MCP',
  'settings.mcpConfigDesc': 'Aggiungi questa configurazione a Claude Desktop (claude_desktop_config.json) o alle impostazioni MCP di Cursor. L\'autenticazione verrà completata automaticamente tramite il browser:',
  'settings.deleteAccount': 'Elimina account',
  'settings.deleteAccountDesc': 'Elimina definitivamente il tuo account e tutte le sessioni, i dati di telemetria, le analisi salvate, i materiali, i setup del kart e le condivisioni associate.',
  'settings.deleteAccountConfirmTitle': 'Eliminare definitivamente l\'account?',
  'settings.deleteAccountConfirmDesc': 'Questa azione non può essere annullata. Tutte le tue sessioni, i dati di telemetria, le analisi salvate, i materiali, i setup del kart, i team e le condivisioni delle sessioni verranno eliminati immediatamente e in modo permanente.',
  'settings.deleteAccountConfirmPrompt': 'Per confermare, digita "{phrase}" nel campo qui sotto:',
  'settings.deleteAccountConfirmPhrase': 'elimina il mio account',
  'settings.deleteAccountConfirmButton': 'Elimina il mio account',

  // Dashboard
  'dashboard.overview': 'Panoramica',
  'dashboard.subtitle': 'Telemetria e dati sui giri',
  'dashboard.recentSessions': 'Sessioni recenti',
  'dashboard.total': '{n} in totale',
  'dashboard.failedToLoadDashboard': 'Impossibile caricare la dashboard',
  'dashboard.noDataAvailable': 'Nessun dato disponibile',

  // Stats
  'stats.sessions': 'Sessioni',
  'stats.laps': 'Giri',
  'stats.trackTime': 'Tempo in pista',
  'stats.tracks': 'Tracciati',

  // Search
  'search.placeholder': 'Cerca sessioni… (es. name:WOHLEN laps:>=5)',
  'search.button': 'Cerca',
  'search.syntaxHelp': 'Guida alla sintassi di ricerca',
  'search.title': 'Sintassi di ricerca',
  'search.subtitle': 'Filtra le sessioni usando coppie campo:valore. Più termini sono combinati con AND.',
  'search.closeDialog': 'Chiudi finestra',
  'search.operatorsTitle': 'Operatori e logica',
  'search.examplesTitle': 'Query di esempio',
  'search.numericComparisons': 'Confronti numerici:',
  'search.range': 'Intervallo:',
  'search.rangeDesc': '— corrisponde a valori compresi tra 5 e 20 inclusi.',
  'search.booleanLogic': 'Logica booleana:',
  'search.booleanLogicDesc': 'I termini sono uniti implicitamente con',
  'search.quotes': 'Virgolette:',
  'search.quotesDesc': 'Racchiudi i valori con spazi tra virgolette doppie, es.',

  // Filter UI
  'filter.add': 'Aggiungi filtro',
  'filter.allActive': 'Tutti i filtri attivi',
  'filter.clearAll': 'Cancella tutto',
  'filter.clear': 'Cancella',
  'filter.apply': 'Applica',
  'filter.cancel': 'Annulla',
  'filter.condition': 'Condizione',
  'filter.presets': 'Predefiniti',
  'filter.customRange': 'Intervallo personalizzato',
  'filter.from': 'Da',
  'filter.to': 'A',
  'filter.min': 'Min',
  'filter.max': 'Max',
  'filter.value': 'Valore',
  'filter.searchOptions': 'Cerca opzioni...',
  'filter.noOptions': 'Nessuna opzione trovata',
  'filter.loadingOptions': 'Caricamento opzioni...',

  // Search fields
  'search.field.bareText': '(testo libero)',
  'search.field.bareTextDesc': 'Corrisponde al nome del tracciato o del pilota che contiene il testo.',
  'search.field.name': 'name',
  'search.field.nameDesc': 'Corrisponde al nome del tracciato o del pilota che contiene il valore.',
  'search.field.driver': 'driver',
  'search.field.driverDesc': 'Corrisponde al nome del pilota che contiene il valore.',
  'search.field.laps': 'laps',
  'search.field.lapsDesc': 'Filtra per numero di giri completati. Supporta =, >, >=, <, <= e intervalli.',
  'search.field.temp': 'temp',
  'search.field.tempDesc': 'Filtra per temperatura meteo (°C). Supporta operatori di confronto e intervalli.',
  'search.field.season': 'season',
  'search.field.seasonDesc': 'Filtra per anno della stagione (estratto dalla data della sessione). Supporta operatori di confronto.',
  'search.field.from': 'from',
  'search.field.fromDesc': 'Sessioni a partire da una data. Accetta YYYY-MM-DD o date relative: -7d, -2w, -3m, -1y.',
  'search.field.to': 'to',
  'search.field.toDesc': 'Sessioni fino a una data. Stessi formati di "from".',

  // Search examples
  'search.example.wohlenLaps': 'Sessioni a Wohlen con almeno 5 giri',
  'search.example.yanick30d': 'Sessioni di Yanick degli ultimi 30 giorni',
  'search.example.tempLaps': 'Sessioni tra 15–25 °C con almeno 3 giri',
  'search.example.wohlenMagny': 'Sessioni a Wohlen o Magny dell\'ultimo anno',

  // Session list
  'sessionList.date': 'Data',
  'sessionList.time': 'Ora',
  'sessionList.track': 'Tracciato',
  'sessionList.sessions': 'Sessioni',
  'sessionList.driver': 'Pilota',
  'sessionList.laps': 'Giri',
  'sessionList.best': 'Migliore',
  'sessionList.weather': 'Meteo',
  'sessionList.lapsUnit': '{n} giri',
  'sessionList.sessionCount': '{count} sessioni',
  'sessionList.sessionCountSingular': '1 sessione',
  'sessionList.noSessions': 'Nessuna sessione trovata. Prova con una ricerca diversa.',

  // Track bests
  'trackBests.title': 'Record dei tracciati',

  // Session detail
  'session.title': 'Sessione',
  'session.failedToLoad': 'Impossibile caricare la sessione',
  'session.noData': 'Nessun dato di sessione',
  'session.chipOverview': 'Panoramica',
  'session.chipDiff': 'Diff',
  'session.tabWeather': 'Meteo',
  'session.tabLaps': 'Giri',
  'session.tabSetup': 'Setup',
  'session.tabManage': 'Gestisci',
  'session.dangerZone': 'Zona pericolosa',
  'session.deleteDescription': 'Elimina definitivamente questa sessione, tutti i giri registrati e i dati di telemetria. Questa azione non può essere annullata.',
  'session.delete': 'Elimina sessione',
  'session.deleteConfirmTitle': 'Elimina sessione',
  'session.deleteConfirmMessage': 'Sei sicuro di voler eliminare questa sessione? Questa azione non può essere annullata e rimuoverà definitivamente tutti i dati dei giri e della telemetria.',
  'session.deleteSuccess': 'Sessione eliminata correttamente',
  'session.deleteFailed': 'Impossibile eliminare la sessione',
  'session.deleting': 'Eliminazione sessione...',

  // Session meta
  'sessionMeta.date': 'Data',
  'sessionMeta.driver': 'Pilota',
  'sessionMeta.track': 'Tracciato',
  'sessionMeta.laps': 'Giri',
  'sessionMeta.device': 'Dispositivo',
  'sessionMeta.status': 'Stato',
  'sessionMeta.tyres': 'Pneumatici',
  'sessionMeta.tyreAge': '{n} giri',
  'sessionMeta.fresh': 'Nuove',

  // Weather
  'weather.wind': 'Vento',
  'weather.humidity': 'Umidità',
  'weather.cloudCover': 'Copertura nuvolosa',
  'weather.precipitation': 'Precipitazioni',
  'weather.pressure': 'Pressione',
  'weather.feels': 'Percepita',
  'weather.clear': 'Sereno',
  'weather.partlyCloudy': 'Parzialmente nuvoloso',
  'weather.overcast': 'Coperto',
  'weather.fog': 'Nebbia',
  'weather.drizzle': 'Pioggerella',
  'weather.rain': 'Pioggia',
  'weather.freezingRain': 'Pioggia gelata',
  'weather.snow': 'Neve',
  'weather.rainShowers': 'Rovesci di pioggia',
  'weather.snowShowers': 'Rovesci di neve',
  'weather.thunderstorm': 'Temporale',
  'weather.unknown': 'Sconosciuto',

  // Lap table
  'lapTable.title': 'Tempi sul giro',
  'lapTable.theoLap': 'Giro più veloce',
  'lapTable.aggregation': 'Aggregazione',
  'lapTable.compare': 'Confronta',
  'lapTable.lapTime': 'Tempo sul giro',
  'lapTable.delta': 'Delta',
  'lapTable.maxRpm': 'RPM Max',
  'lapTable.minRpm': 'RPM Min',
  'lapTable.maxSpeed': 'Vel. Max',
  'lapTable.minSpeed': 'Vel. Min',
  'lapTable.tyreAge': 'Usura gomme',

  // Diff chart
  'diffChart.outlierLap': 'Anomalo',
  'diffChart.deltaToBest': 'Delta dal migliore',

  // Lap analysis
  'lapAnalysis.title': 'Analisi Giro {n}',
  'lapAnalysis.resetZoom': 'Reimposta zoom',
  'lapAnalysis.speed': 'Velocità',
  'lapAnalysis.acceleration': 'Accelerazione',
  'lapAnalysis.rpm': 'RPM',
  'lapAnalysis.gForce': 'Forza G',
  'lapAnalysis.trackMap': 'Mappa tracciato',
  'lapAnalysis.failedToLoad': 'Impossibile caricare la telemetria',
  'lapAnalysis.noTelemetry': 'Nessun dato di telemetria per questo giro.',

  // Lap info
  'lapInfo.lapTime': 'Tempo sul giro',
  'lapInfo.maxRpm': 'RPM Max',
  'lapInfo.minRpm': 'RPM Min',
  'lapInfo.maxSpeed': 'Vel. Max',
  'lapInfo.maxTemp': 'Temp. Max',
  'lapInfo.gpsOffset': 'Offset GPS',
  'lapInfo.gpsOffsetTooltip': 'Deriva GPS corretta: {east} E, {north} N',

  // Navigation
  'nav.data': 'Dati',
  'nav.home': 'Sessioni',
  'nav.tools': 'Strumenti',
  'nav.compare': 'Confronta',
  'nav.drivers': 'Piloti',
  'nav.tracks': 'Tracciati',
  'nav.settings': 'Impostazioni',

  // Analysis
  'analysis.title': 'Strumenti di analisi',
  'analysis.subtitle': 'Approfondisci i tuoi dati di telemetria con strumenti di analisi specializzati.',
  'analysis.sector.title': 'Analisi di settore',
  'analysis.sector.desc': 'Confronta i settori del giro su più sessioni per calcolare il miglior giro teorico e analizzare la costanza.',


  // Braking Analysis
  'analysis.braking.title': 'Analisi frenata',
  'analysis.braking.desc': 'Analizza punti di staccata, zone di decelerazione, cerchi di aderenza G-G ed efficacia del trail-braking.',
  'braking.title': 'Analisi frenata',
  'braking.desc': 'Analizza punti di staccata, zone di decelerazione, cerchi di aderenza G-G ed efficacia del trail-braking.',
  'braking.wizardChooseTrack': 'Scegli tracciato',
  'braking.wizardSelect': 'Seleziona sessioni',
  'braking.wizardResults': 'Risultati',
  'braking.noTracksWithCorners': 'Nessun tracciato disponibile con geometria e curve configurate.',
  'braking.noSessionsForTrack': 'Nessuna sessione trovata per il tracciato',
  'braking.noBrakingZones': 'Nessuna zona di frenata rilevata per questo tracciato.',
  'braking.selectZone': 'Seleziona zona di frenata',
  'braking.zone': 'Zona di frenata',
  'braking.zones': 'Zone di frenata',
  'braking.brakePoint': 'Punto di staccata',
  'braking.apex': 'Punto di corda',
  'braking.exit': 'Uscita',
  'braking.distance': 'Spazio di frenata',
  'braking.duration': 'Durata frenata',
  'braking.initialSpeed': 'Velocità iniziale',
  'braking.apexSpeed': 'Velocità minima',
  'braking.minSpeed': 'Velocità minima',
  'braking.brakeRelease': 'Rilascio freno',
  'braking.exitSpeed': 'Velocità di uscita',
  'braking.speedDrop': 'Riduzione velocità',
  'braking.peakDecel': 'Decelerazione di picco',
  'braking.peakLateral': 'Grip laterale di picco',
  'braking.trailScore': 'Punteggio Trail-Braking',
  'braking.trailScoreDesc': 'Misura dell\'utilizzo del cerchio di aderenza nella transizione dalla frenata longitudinale alla percorrenza laterale in curva.',
  'braking.scoreOptimal': 'Ottimale',
  'braking.scoreGood': 'Buono',
  'braking.scoreNeedsWork': 'Migliorabile',
  'braking.sessionMedian': 'Mediana sessione',
  'braking.selectedLap': 'Giro selezionato',
  'braking.speedTransition': 'Transizione di velocità',
  'braking.decelAndGrip': 'Decelerazione e grip',
  'braking.trailScoreAdviceOptimal': 'Ottima modulazione del freno in ingresso curva. Elevato utilizzo del cerchio di aderenza.',
  'braking.trailScoreAdviceGood': 'Transizione fluida. Margine per prolungare leggermente la frenata fin dentro l\'ingresso curva.',
  'braking.trailScoreAdviceNeedsWork': 'Rilascio brusco del freno prima dell\'inserimento. Concentrati su un rilascio progressivo mentre inserisci il kart.',
  'braking.overallHeader': 'Prestazioni complessive in frenata',
  'braking.overallHeaderDesc': 'Efficacia del trail-braking sull\'intero tracciato e costanza in curva su tutti i giri e le sessioni selezionate.',
  'braking.perCornerHeader': 'Analisi per curva',
  'braking.perCornerHeaderDesc': 'Cinematica dettagliata, cerchio di aderenza G-G e tracce telemetriche per la zona di frenata selezionata.',
  'braking.overallScore': 'Punteggio Trail-Braking complessivo',
  'braking.overallScoreDesc': 'Utilizzo medio del cerchio di aderenza su tutte le curve e i giri',
  'braking.mostConsistentCorner': 'Curva più costante',
  'braking.leastConsistentCorner': 'Curva meno costante',
  'braking.consistency': 'Costanza',
  'braking.lapTimeline': 'Andamento punteggio giro per giro',
  'braking.sessionComparison': 'Confronto sessioni',
  'braking.selectCornerHint': 'Fai clic per ispezionare la curva',
  'braking.stdDevLabel': 'Dev.St.',
  'braking.ggDiagram': 'Diagramma G-G',
  'braking.frictionCircle': 'Cerchio di aderenza',
  'braking.telemetryChart': 'Telemetria frenata',
  'braking.speed': 'Velocità',
  'braking.gLong': 'G longitudinale',
  'braking.gLat': 'G laterale',
  'braking.gTotal': 'G combinata',
  'braking.allLaps': 'giri',
  'braking.compareLap': 'Confronta',
  'braking.comparisonLap': 'Confronto',
  'braking.clearComparison': 'Cancella confronto',
  'braking.lapTime': 'Tempo sul giro',
  'braking.driver': 'Pilota',
  'braking.lap': 'Giro',
  'braking.lapSpeedTable': 'Dettaglio giri in frenata',
  'braking.lapsAnalyzed': 'giri analizzati',
  'braking.legendDecel': 'Frenata sul dritto',
  'braking.legendTrail': 'Trail-Braking',
  'braking.legendApex': 'Punto di corda',
  'braking.legendExit': 'Accelerazione in uscita',

  // Corner Speed Analysis
  'analysis.corner.title': 'Analisi velocità in curva',
  'analysis.corner.desc': 'Misura e confronta le velocità di ingresso, percorrenza (punto di corda) e uscita curva tra giri e sessioni.',
  'corner.title': 'Analisi velocità in curva',
  'corner.wizardChooseTrack': 'Scegli tracciato',
  'corner.wizardSelect': 'Seleziona sessioni',
  'corner.wizardResults': 'Risultati',
  'corner.entrance': 'Ingresso',
  'corner.apex': 'Corda',
  'corner.exit': 'Uscita',
  'corner.entranceSpeed': 'Velocità di ingresso',
  'corner.apexSpeed': 'Velocità alla corda',
  'corner.exitSpeed': 'Velocità di uscita',
  'corner.speedGain': 'Guadagno di velocità',
  'corner.turn': 'Curva',
  'corner.leftTurn': 'Curva a sinistra',
  'corner.rightTurn': 'Curva a destra',
  'corner.avgSpeed': 'Velocità media',
  'corner.maxSpeed': 'Velocità max',
  'corner.minSpeed': 'Velocità min',
  'corner.fastest': 'Più veloce',
  'corner.slowest': 'Più lento',
  'corner.spread': 'Dispersione',
  'corner.deltaToBest': 'Δ dal migliore',
  'corner.deltaToAvg': 'Δ dalla media',
  'corner.allCornersOverview': 'Panoramica di tutte le curve',
  'corner.aggregatedData': 'Statistiche di velocità aggregate',
  'corner.lapSpeedTable': 'Dettaglio velocità per giro',
  'corner.lapsAnalyzed': 'giri analizzati',
  'corner.noTracksWithCorners': 'Nessun tracciato disponibile con geometria e curve configurate.',
  'corner.noSessionsForTrack': 'Nessuna sessione trovata per il tracciato',
  'corner.noCornersFound': 'Nessuna annotazione di curva trovata per questo tracciato.',
  'corner.selectCorner': 'Seleziona curva',
  'corner.rank': 'Pos.',
  'corner.driver': 'Pilota',
  'corner.lap': 'Giro',
  'corner.lapTime': 'Tempo sul giro',
  'corner.session': 'Sessione',
  'corner.speed': 'Velocità',
  'corner.avgMax': 'Media / Max',
  'corner.activeMetric': 'Metrica attiva:',
  'corner.metricSpeed': 'Velocità',
  'corner.metricRpm': 'RPM',
  'corner.metricDuration': 'Durata',
  'corner.entranceRpm': 'RPM ingresso',
  'corner.apexRpm': 'RPM alla corda',
  'corner.exitRpm': 'RPM uscita',
  'corner.rpmGain': 'Guadagno RPM',
  'corner.rpm': 'RPM',
  'corner.duration': 'Durata',
  'corner.transitDuration': 'Tempo di percorrenza curva',
  'corner.bestDuration': 'Miglior durata',
  'corner.avgDuration': 'Durata media',
  'corner.worstDuration': 'Durata più lenta',
  'corner.deltaToBestDuration': 'Δ dal migliore',
  'corner.fullTransit': 'Percorrenza completa',



  // Sector analysis
  'sector.wizardChooseTrack': 'Scegli tracciato',
  'sector.wizardDefine': 'Definisci settori',
  'sector.wizardSelect': 'Seleziona sessioni',
  'sector.wizardResults': 'Risultati',
  'sector.title': 'Analisi di settore',
  'sector.defineSectors': 'Definisci settori',
  'sector.clickToAdd': 'Fai clic per aggiungere · Trascina per spostare (max 3 settori)',
  'sector.selectSessions': 'Seleziona sessioni →',
  'sector.analyzingLap': '⏳ Analisi del giro…',
  'sector.analyzeLap': '⚡ Analizza giro',
  'sector.noResults': 'Nessun risultato disponibile',
  'sector.noResultsHint': 'Torna indietro e modifica i settori o le sessioni',
  'sector.trackSectors': 'Settori del tracciato',
  'sector.sectorN': 'Settore {n}',
  'sector.noSessionsForTrack': 'Nessuna sessione trovata per il tracciato',
  'sector.failedToLoad': 'Impossibile caricare l\'analisi di settore',
  'sector.lapStats': 'Statistiche sul giro',
  'sector.lapStatsDriver': 'Pilota',
  'sector.lapStatsTotal': 'Totale',

  // Sector panel
  'sectorPanel.time': 'Tempo',
  'sectorPanel.topSpeed': 'Velocità di punta',
  'sectorPanel.minSpeed': 'Vel. Min',
  'sectorPanel.maxRpm': 'RPM Max',
  'sectorPanel.minRpm': 'RPM Min',
  'sectorPanel.duration': 'Durata',
  'sectorPanel.best': 'Migliore',
  'sectorPanel.avg': 'Media',
  'sectorPanel.median': 'Mediana',
  'sectorPanel.worst': 'Peggiore',
  'sectorPanel.p10': 'P10',
  'sectorPanel.p5': 'P5',
  'sectorPanel.consistency': 'Costanza',
  'sectorPanel.lapByLap': 'Andamento giro per giro',
  'sectorPanel.sessionMedians': 'Mediane di sessione',
  'sectorPanel.medianTopSpeed': 'Mediana vel. di punta',
  'sectorPanel.medianMinSpeed': 'Mediana vel. min',
  'sectorPanel.medianMaxRpm': 'Mediana RPM max',
  'sectorPanel.medianMinRpm': 'Mediana RPM min',
  'sectorPanel.medianTime': 'Tempo mediano',
  'sectorPanel.session': 'Sessione',
  'sectorPanel.lap': 'Giro',
  'sectorPanel.maxSpeed': 'Vel. Max',

  // Split points
  'splitPoints.clearAll': 'Cancella tutto',

  // Session selector
  'sessionSelector.allDrivers': 'Tutti i piloti',
  'sessionSelector.allWeather': 'Qualsiasi meteo',
  'sessionSelector.dryOnly': '☀️ Solo asciutto',
  'sessionSelector.wetOnly': '🌧️ Solo bagnato',
  'sessionSelector.selectAll': 'Seleziona tutto',
  'sessionSelector.deselectAll': 'Deseleziona tutto',

  // Theoretical best
  'theoBest.title': 'Miglior giro teorico',
  'theoBest.type': 'Tipo',
  'theoBest.time': 'Tempo',
  'theoBest.delta': 'Delta',
  'theoBest.theoretical': 'Teorico',
  'theoBest.actualBest': 'Migliore effettivo',

  // Lap selector
  'lapSelector.title': 'Seleziona giri',
  'lapSelector.loadingLaps': 'Caricamento giri…',
  'lapSelector.noLaps': 'Nessun giro',
  'lapSelector.best': 'MIGLIORE',

  // Navigation – races
  'nav.races': 'Gare',

  // Tracks
  'tracks.title': 'Tracciati',
  'tracks.subtitle': 'Tutti i tracciati e le classifiche',
  'tracks.noData': 'Nessun tracciato disponibile',
  'tracks.failedToLoad': 'Impossibile caricare i tracciati',
  'tracks.sessions': '{n} sessioni',
  'tracks.raceSessions': '{n} sessioni di gara',
  'tracks.bestLap': 'Miglior giro',
  'tracks.rank': '#',
  'tracks.lapTime': 'Tempo sul giro',
  'tracks.driver': 'Pilota',
  'tracks.date': 'Data',
  'tracks.sectors': 'Settori',
  'tracks.weather': 'Meteo',
  'tracks.measuredLapsTab': 'Giri telemetrici',
  'tracks.raceTab': 'Gare',
  'tracks.leaderboard': 'Classifica',
  'tracks.category': 'Categoria',
  'tracks.season': 'Stagione',
  'tracks.position': 'Pos.',
  'tracks.sessionType': 'Tipo',
  'tracks.sourceCanonical': 'Tracciato',
  'tracks.sourceSession': 'Solo sessione',
  'tracks.sourceRaceEvent': 'Solo gara',
  'tracks.searchPlaceholder': 'Cerca tracciati…',
  'tracks.source': 'Fonte',
  'tracks.searchHelp.title': 'Sintassi di ricerca tracciati',
  'tracks.searchHelp.subtitle': 'Cerca per nome del tracciato. La ricerca non distingue tra maiuscole/minuscole e accenti.',
  'tracks.searchHelp.nameField': '(testo)',
  'tracks.searchHelp.nameDesc': 'Corrisponde ai tracciati il cui nome contiene il testo indicato. I caratteri accentati vengono riconosciuti indipendentemente dagli accenti (es. "Geneve" corrisponde a "Genève").',
  'tracks.searchHelp.example1': 'Wohlen',
  'tracks.searchHelp.example1Desc': 'Tutti i tracciati che contengono "Wohlen"',
  'tracks.searchHelp.example2': 'franciacorta',
  'tracks.searchHelp.example2Desc': 'Corrispondenza senza distinzione maiuscole/minuscole per "Franciacorta"',
  'tracks.searchHelp.example3': 'Sarno',
  'tracks.searchHelp.example3Desc': 'Tutti i tracciati che contengono "Sarno"',

  // Track detail tabs
  'tracks.layoutTab': 'Tracciato',
  'tracks.noTrackLayout': 'Nessuna mappa del tracciato disponibile',
  'tracks.officialLapsTab': 'Giri ufficiali',
  'tracks.noRaceEvents': 'Nessun evento di gara trovato',
  'tracks.round': 'Round',
  'tracks.championship': 'Campionato',
  'tracks.dateStart': 'Data',
  'tracks.country': 'Paese',
  'tracks.sessionsCount': 'Sessioni',
  'tracks.driversCount': 'Piloti',
  // Track race events search
  'tracks.raceEvents.searchPlaceholder': 'Cerca eventi di gara…',
  'tracks.raceEvents.searchHelp.title': 'Ricerca eventi di gara',
  'tracks.raceEvents.searchHelp.subtitle': 'Filtra gli eventi di gara per stagione o nome del campionato',
  'tracks.raceEvents.searchHelp.seasonField': 'season:<anno>',
  'tracks.raceEvents.searchHelp.seasonDesc': 'Filtra per anno della stagione (corrispondenza esatta)',
  'tracks.raceEvents.searchHelp.championshipField': 'championship:<nome>',
  'tracks.raceEvents.searchHelp.championshipDesc': 'Filtra per nome del campionato (senza distinzione maiuscole/minuscole)',
  'tracks.raceEvents.searchHelp.example1': 'season:2026',
  'tracks.raceEvents.searchHelp.example1Desc': 'Tutti gli eventi della stagione 2026',
  'tracks.raceEvents.searchHelp.example2': 'championship:RMC',
  'tracks.raceEvents.searchHelp.example2Desc': 'Tutti gli eventi dei campionati che contengono "RMC"',

  // Track leaderboard search
  'tracks.leaderboard.searchPlaceholder': 'Cerca giri...',
  'tracks.leaderboard.searchHelp.title': 'Ricerca classifica',
  'tracks.leaderboard.searchHelp.subtitle': 'Usa i filtri per restringere i risultati',
  'tracks.leaderboard.searchHelp.driverField': 'driver:<nome>',
  'tracks.leaderboard.searchHelp.driverDesc': 'Filtra per nome del pilota (senza distinzione maiuscole/minuscole)',
  'tracks.leaderboard.searchHelp.seasonField': 'season:<anno>',
  'tracks.leaderboard.searchHelp.seasonDesc': 'Filtra per anno della stagione',
  'tracks.leaderboard.searchHelp.categoryField': 'category:<nome>',
  'tracks.leaderboard.searchHelp.categoryDesc': 'Filtra per categoria (es. DD2, Junior)',
  'tracks.leaderboard.searchHelp.typeField': 'type:<tipoSessione>',
  'tracks.leaderboard.searchHelp.typeDesc': 'Filtra per tipo di gara (qualifying, heat-1, final...)',
  'tracks.leaderboard.searchHelp.posField': 'pos<:<N>',
  'tracks.leaderboard.searchHelp.posDesc': 'Posizione massima al traguardo (es. pos<:3 = podio)',
  'tracks.leaderboard.searchHelp.tempMinField': 'temp>:<N>',
  'tracks.leaderboard.searchHelp.tempMinDesc': 'Temperatura minima in °C',
  'tracks.leaderboard.searchHelp.tempMaxField': 'temp<:<N>',
  'tracks.leaderboard.searchHelp.tempMaxDesc': 'Temperatura massima in °C',
  'tracks.leaderboard.searchHelp.fromField': 'from:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.fromDesc': 'Filtro data di inizio',
  'tracks.leaderboard.searchHelp.toField': 'to:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.toDesc': 'Filtro data di fine',
  'tracks.leaderboard.searchHelp.example1': 'driver:gubser season:2026',
  'tracks.leaderboard.searchHelp.example1Desc': 'Trova un pilota nella stagione 2026',
  'tracks.leaderboard.searchHelp.example2': 'category:dd2 type:final',
  'tracks.leaderboard.searchHelp.example2Desc': 'Solo finali DD2',
  'tracks.leaderboard.searchHelp.example3': 'pos<:3 from:2026-01-01',
  'tracks.leaderboard.searchHelp.example3Desc': 'Piazzamenti a podio nel 2026',

  // Drivers
  'drivers.title': 'Piloti',
  'drivers.driver': 'Pilota',
  'drivers.events': 'Eventi',
  'drivers.noData': 'Nessun pilota trovato',
  'drivers.failedToLoad': 'Impossibile caricare i piloti',
  'drivers.searchPlaceholder': 'Cerca per nome…',

  // Races
  'races.title': 'Risultati di gara',
  'races.seasons': 'Stagioni',
  'races.events': '{n} eventi',
  'races.categories': '{n} categorie',
  'races.round': 'Round {n}',
  'races.allCategories': 'Tutte le categorie',
  'races.noEvents': 'Nessun evento trovato',
  'races.failedToLoad': 'Impossibile caricare i dati di gara',
  'races.noData': 'Nessun dato di gara disponibile',
  'races.position': 'Pos',
  'races.kart': '#',
  'races.driver': 'Pilota',
  'races.bestLap': 'Miglior giro',
  'races.totalTime': 'Tempo totale',
  'races.gap': 'Distacco',
  'races.status': 'Stato',
  'races.grid': 'Griglia',
  'races.lap': 'Giro',
  'races.laps': 'Giri',
  'races.penalty': 'Penalità',
  'races.lapProgression': 'Progressione giri',
  'races.results': 'Risultati',
  'races.driverHistory': 'Storico pilota',
  'races.raceStarts': 'Partenze',
  'races.podiums': 'Podi',
  'races.dnfDsq': 'Ritiri / Squalifiche',
  'races.qualiPoles': 'Pole in qualifica',
  'races.track': 'Tracciato',
  'races.session': 'Sessione',
  'races.year': 'Anno',
  'races.category': 'Categoria',
  'races.pole': 'Pole',
  'races.winner': 'Vincitore',
  'races.finish': 'Arrivo',
  'races.sessionType.qualifying': 'Qualifica',
  'races.sessionType.heat-1': 'Manche 1',
  'races.sessionType.heat-2': 'Manche 2',
  'races.sessionType.heat-3': 'Manche 3',
  'races.sessionType.heat-ab': 'Manche A-B',
  'races.sessionType.heat-bc': 'Manche B-C',
  'races.sessionType.heat-ac': 'Manche A-C',
  'races.sessionType.final': 'Finale',

  // Race overview
  'races.overview': 'Panoramica',

  // Driver race search
  'races.searchPlaceholder': 'Cerca gare… es. Castelletto o type:race',
  'races.querySyntaxHelp': 'Guida alla sintassi di ricerca',
  'races.sessionCount': '{count} sessioni',
  'races.sessionCountSingular': '1 sessione',
  'races.eventsFound': '{n} evento/i trovato/i',

  // Session detail tabs (below results table)
  'races.sessionTabWeather': 'Meteo',
  'races.sessionTabPace': 'Passo gara',
  'common.comingSoon': 'Prossimamente',

  // Driver pace
  'races.tabRaces': 'Gare',
  'races.tabStats': 'Statistiche',
  'races.tabPace': 'Passo gara',
  'races.paceDescription': 'Giro più veloce per fase di gara',
  'races.paceNoData': 'Nessun dato sul passo gara disponibile per questa categoria.',
  'races.paceEvents': '{n} eventi',
  'races.paceQualifying': 'Miglior tempo sul giro su tutti gli eventi',

  // Driver stats
  'races.statWins': 'Vittorie',
  'races.statAvgFinish': 'Posizione media all\'arrivo',
  'races.statSeasons': 'Stagioni',
  'races.statTracks': 'Tracciati',
  'races.statCategories': 'Categorie',
  'races.statTotalLaps': 'Giri totali',

  'driverSearchHelp.title': 'Sintassi di ricerca gare',
  'driverSearchHelp.subtitle': 'Filtra i risultati di gara usando coppie campo:valore. Più termini sono combinati con AND.',
  'driverSearchHelp.bareText': '(testo libero)',
  'driverSearchHelp.bareTextDesc': 'Corrisponde al nome del tracciato o del campionato che contiene il testo.',
  'driverSearchHelp.track': 'track',
  'driverSearchHelp.trackDesc': 'Corrisponde al nome del tracciato che contiene il valore.',
  'driverSearchHelp.championship': 'championship',
  'driverSearchHelp.championshipDesc': 'Corrisponde al nome del campionato che contiene il valore.',
  'driverSearchHelp.category': 'category',
  'driverSearchHelp.categoryDesc': 'Corrisponde al nome della categoria che contiene il valore.',
  'driverSearchHelp.type': 'type',
  'driverSearchHelp.typeDesc': 'Corrisponde al tipo o all\'etichetta della sessione (es. race, qualifying, heat).',
  'driverSearchHelp.position': 'position',
  'driverSearchHelp.positionDesc': 'Filtra per posizione al traguardo. Supporta =, >, >=, <, <= e intervalli.',
  'driverSearchHelp.laps': 'laps',
  'driverSearchHelp.lapsDesc': 'Filtra per giri completati. Supporta operatori di confronto e intervalli.',
  'driverSearchHelp.season': 'season',
  'driverSearchHelp.seasonDesc': 'Filtra per anno della stagione di campionato. Supporta operatori di confronto.',
  'driverSearchHelp.from': 'from',
  'driverSearchHelp.fromDesc': 'Gare a partire da una data. Accetta YYYY-MM-DD o date relative: -7d, -2w, -3m, -1y.',
  'driverSearchHelp.to': 'to',
  'driverSearchHelp.toDesc': 'Gare fino a una data. Stessi formati di "from".',
  'driverSearchHelp.operatorsTitle': 'Operatori e logica',
  'driverSearchHelp.numericComparisons': 'Confronti numerici:',
  'driverSearchHelp.range': 'Intervallo:',
  'driverSearchHelp.rangeDesc': '— corrisponde a valori compresi tra 5 e 20 inclusi.',
  'driverSearchHelp.booleanLogic': 'Logica booleana:',
  'driverSearchHelp.booleanLogicDesc': 'I termini sono uniti implicitamente con',
  'driverSearchHelp.quotes': 'Virgolette:',
  'driverSearchHelp.quotesDesc': 'Racchiudi i valori con spazi tra virgolette doppie, es.',
  'driverSearchHelp.examplesTitle': 'Query di esempio',
  'driverSearchHelp.example1Desc': 'Risultati di gara a Castelletto',
  'driverSearchHelp.example2Desc': 'Podi nel campionato RMC dell\'ultimo anno',
  'driverSearchHelp.example3Desc': 'Risultati in finale nella top 3',

  // Drivers List Search Help
  'driversListSearchHelp.title': 'Ricerca piloti',
  'driversListSearchHelp.subtitle': 'Trova piloti per nome',
  'driversListSearchHelp.bareText': 'Parole chiave',
  'driversListSearchHelp.bareTextDesc': 'Le parole chiave vengono cercate nel nome e nel cognome. Più parole chiave sono trattate come condizioni AND.',
  'driversListSearchHelp.from': 'from',
  'driversListSearchHelp.fromDesc': 'Piloti attivi a partire da una data. Accetta YYYY-MM-DD o date relative: -7d, -2w, -3m, -1y.',
  'driversListSearchHelp.to': 'to',
  'driversListSearchHelp.toDesc': 'Piloti attivi fino a una data. Stessi formati di "from".',
  'driversListSearchHelp.season': 'season',
  'driversListSearchHelp.seasonDesc': 'Piloti attivi in una specifica stagione di campionato. Supporta operatori di confronto come season:>2020.',
  'driversListSearchHelp.category': 'category',
  'driversListSearchHelp.categoryDesc': 'Piloti attivi in una specifica categoria (es. Rotax Max).',
  'driversListSearchHelp.example.yanick': 'Trova piloti di nome Yanick',
  'driversListSearchHelp.example.senn': 'Trova piloti di cognome Senn',
  'driversListSearchHelp.example.from': 'Piloti attivi dal 2026',
  'driversListSearchHelp.example.season': 'Piloti attivi nel 2025 o successivi',
  'driversListSearchHelp.example.category': 'Piloti attivi in Rotax Max',
  'drivers.lastAppearance': 'Ultima presenza',

  // Tyre Analysis
  'analysis.tyre.title': 'Analisi pneumatici',
  'analysis.tyre.desc': 'Analizza lo storico dei treni di gomme e prevedi tempi sul giro realistici in base alle condizioni attuali.',
  'tyre.selectTitle': 'Seleziona treno di gomme',
  'tyre.selectHint': 'Vengono mostrati i treni di gomme usati più di recente. Puoi anche scansionare un codice a barre.',
  'tyre.scanBarcode': 'Scansiona',
  'tyre.barcodeSearch': 'Cerca per codice a barre o nome...',
  'tyre.fastestLaps': 'Giri più veloci per tracciato',
  'tyre.expectations': 'Previsioni realistiche',
  'tyre.totalLaps': 'Giri totali percorsi',
  'tyre.totalSessions': 'Sessioni',
  'tyre.longestSession': 'Sessione più lunga',
  'tyre.ageLaps': '{n} giri',
  'tyre.noData': 'Nessun dato',
  'tyre.expectedMedian': 'Previsto',
  'tyre.matchingLaps': 'Giri corrispondenti',
  'tyre.noTyresFound': 'Nessun treno di gomme trovato.',
  'tyre.noFastestLaps': 'Nessun giro registrato con questo treno di gomme.',
  'tyre.noExpectations': 'Nessun tracciato con dati GPS disponibile per le previsioni.',
  'tyre.dry': 'Asciutto (Slick)',
  'tyre.wet': 'Bagnato (Rain)',
  'tyre.pointCamera': 'Inquadra un codice a barre con la fotocamera',
  'tyre.wizardSelect': 'Seleziona gomme',
  'tyre.wizardResults': 'Risultati',
  'tyre.back': 'Indietro',
  'tyre.exit': 'Esci',
  'tyre.trackColumn': 'Tracciato',
  'tyre.bestLapColumn': 'Miglior giro',
  'tyre.dateColumn': 'Data',
  'tyre.ageColumn': 'Usura',
  'tyre.weatherColumn': 'Meteo',
  'tyre.tempColumn': 'Temp.',
  'tyre.expected': 'Previsto:',

  // Tyre Overview
  'analysis.tyreOverview.title': 'Panoramica pneumatici',
  'tyreOverview.summaryTotal': 'Totale',
  'tyreOverview.summaryFresh': 'Nuove',
  'tyreOverview.summaryWorn': 'Usate',
  'tyreOverview.summaryEndOfLife': 'Fine vita',
  'tyreOverview.endOfLife': '⚠ Fine vita',
  'tyreOverview.scanButton': 'Scansiona',
  'tyreOverview.noTyres': 'Nessun pneumatico attivo trovato.',
  'tyreOverview.scanNotFound': 'Nessun pneumatico trovato per il codice a barre scansionato.',
  'tyreOverview.laps': 'giri',
  'tyreOverview.colTyre': 'Pneumatico',
  'tyreOverview.colCompound': 'Mescola',
  'tyreOverview.colLaps': 'Giri',
  'tyreOverview.colLastUsed': 'Ultimo utilizzo',
  'tyreOverview.colStatus': 'Stato',
  'tyreOverview.discardButton': 'Segna come smaltito',
  'tyreOverview.discardAction': 'Smaltisci',
  'tyreOverview.discardSuccess': 'Treno di gomme contrassegnato come smaltito.',
  'tyreOverview.searchPlaceholder': 'Cerca gomme (es. brand:Mojo compound:dry laps:<50)...',
  'tyreOverview.searchHelp.title': 'Ricerca panoramica pneumatici',
  'tyreOverview.searchHelp.subtitle': 'Filtra e trova i treni di gomme attivi per marca, mescola, giri, codice a barre o tracciato.',
  'tyreOverview.searchHelp.bareText': 'Testo',
  'tyreOverview.searchHelp.bareTextDesc': 'Corrisponde a marca, modello, numero di riferimento, codice a barre o nome dell\'ultimo tracciato utilizzato.',
  'tyreOverview.searchHelp.brandDesc': 'Filtra per produttore o marca del pneumatico (es. Mojo, Vega).',
  'tyreOverview.searchHelp.typeDesc': 'Filtra per modello o tipo di pneumatico (es. D2, White).',
  'tyreOverview.searchHelp.nrDesc': 'Filtra per numero di riferimento del treno di gomme.',
  'tyreOverview.searchHelp.compoundDesc': 'Filtra per tipo di mescola ("dry" o "wet").',
  'tyreOverview.searchHelp.lapsDesc': 'Filtra per giri totali percorsi con operatori di confronto (=, >, <, >=, <=) o intervalli (es. 0..20).',
  'tyreOverview.searchHelp.barcodeDesc': 'Filtra per codice a barre/ID seriale del singolo pneumatico.',
  'tyreOverview.searchHelp.trackDesc': 'Filtra per nome del tracciato in cui il treno di gomme è stato usato l\'ultima volta.',
  'tyreOverview.searchHelp.fromDesc': 'Corrisponde a gomme usate l\'ultima volta a partire dalla data (YYYY-MM-DD o relativa come -30d).',
  'tyreOverview.searchHelp.toDesc': 'Corrisponde a gomme usate l\'ultima volta entro la data (YYYY-MM-DD o relativa come -1m).',
  'tyreOverview.searchHelp.example.mojoDry': 'Pneumatici da asciutto (slick) Mojo',
  'tyreOverview.searchHelp.example.lapsEol': 'Pneumatici che hanno raggiunto la fine vita (70+ giri)',
  'tyreOverview.searchHelp.example.lapsRange': 'Pneumatici nuovi o poco usati con 0–20 giri',
  'tyreOverview.searchHelp.example.trackFrom': 'Pneumatici usati l\'ultima volta a Lonato dal 1° agosto 2026',
  'tyreOverview.searchHelp.example.vegaWet': 'Pneumatici Vega oppure gomme da bagnato (rain)',

  // Devices
  'device.alfano7': 'Alfano 7',
  'device.mychron5': 'MyChron 5',

  // Import
  'import.title': 'Importa sessioni',
  'import.uploadZip': 'Carica file di telemetria',
  'import.uploadZipDesc': 'Carica file di telemetria Alfano 7 (ZIP) o MyChron 5 (.xrk, .xrz, ZIP) dal tuo computer',
  'import.dragDropZip': 'Trascina e rilascia qui i file ZIP, XRK o XRZ',
  'import.dropZipHere': 'Rilascia qui i file',
  'import.orBrowse': 'oppure',
  'import.browseFiles': 'sfoglia i file',
  'import.filesSelected': '{n} file selezionato/i',
  'import.upload': 'Carica',
  'import.uploading': 'Caricamento…',
  'import.uploadingPct': 'Caricamento… {n}%',
  'import.imported': 'Importate',
  'import.skipped': 'Ignorate',
  'import.errors': 'Errori',
  'import.errorDetailsTitle': 'Dettagli errore',
  'import.successMessage': 'Sessioni importate correttamente. Appariranno nella tua dashboard.',
  'import.noNewSessions': 'Nessuna nuova sessione trovata. Tutti i file erano già stati importati.',
  'import.onlyZipAccepted': 'Sono accettati solo file ZIP, XRK e XRZ',
  'import.onlySupportedAccepted': 'Sono accettati solo file ZIP, XRK e XRZ',
  'import.uploadFailed': 'Caricamento non riuscito (HTTP {status})',
  'import.connectionLost': 'Connessione persa',
  'import.uploadAborted': 'Caricamento annullato',
  'import.importFailed': 'Importazione non riuscita',
  'import.importedFromZip': '{n} sessione/i importata/e',
  'import.zipImportFailed': 'Importazione non riuscita: {error}',
  'import.useCurrentSetup': 'Usa setup attuale',
  'offline.title': 'Sei offline',
  'offline.message': 'Al momento non sei connesso a Internet. Controlla la tua connessione di rete e riprova.',
  'settings.uploadSessions': 'Carica sessioni',
  'settings.uploadSessionsDesc': 'Carica file di telemetria Alfano 7 o MyChron 5 per importare i dati delle tue sessioni.',
  // Sharing
  'sharing.title': 'Condivisione',
  'sharing.searchPlaceholder': 'Cerca utenti per nome o email...',
  'sharing.noUsersFound': 'Nessun utente trovato',
  'sharing.shareAll': 'Condividi tutte le sessioni',
  'sharing.shareSelected': 'Condividi solo le selezionate',
  'sharing.readOnly': 'Sola lettura',
  'sharing.readWrite': 'Lettura e scrittura',
  'sharing.share': 'Condividi',
  'sharing.myShares': 'Le mie condivisioni (in uscita)',
  'sharing.sharedWithMe': 'Condivisi con me (in entrata)',
  'sharing.revoke': 'Revoca',
  'sharing.leave': 'Abbandona',
  'sharing.permissions': 'Autorizzazioni',
  'sharing.sharedAll': 'Tutte le sessioni',
  'sharing.sharedSelected': 'Sessioni selezionate',
  'sharing.searching': 'Ricerca…',
  'sharing.owner': 'Proprietario: {name}',
  'sharing.selectSessions': 'Seleziona sessioni',
  'sharing.noSessions': 'Nessuna sessione disponibile',
  'sharing.laps': 'giri',
  'sharing.searchHint': 'Digita almeno 2 caratteri per cercare',
  'sharing.newShare': 'Nuova condivisione',
  'sharing.stepUsers': 'Passaggio 1: Seleziona utenti',
  'sharing.stepConfigure': 'Passaggio 2: Configura condivisione',
  'sharing.stepPermissions': 'Passaggio 3: Autorizzazioni',
  'sharing.next': 'Avanti',
  'sharing.selectedUsers': 'Utenti selezionati',
  'sharing.selectedSessions': '{count} sessione/i selezionata/e',
  'sharing.filterSessions': 'Filtra sessioni...',
  'sharing.showSelected': 'Mostra selezionate',
  'sharing.noSharesYet': 'Ancora nessuna condivisione',
  'sharing.emptyDescription': 'Condividi le tue sessioni con altri piloti o meccanici.',
  'sharing.stepScope': 'Passaggio 1: Seleziona sessioni',
  'sharing.stepConfirm': 'Passaggio 2: Conferma',
  'sharing.shareWithTeam': 'Condividi con questo team',

  // Session tabs

  // Setup (readonly view)
  'setup.noSetup': 'Nessun dato di setup disponibile per questa sessione.',
  'setup.loadingSetup': 'Caricamento setup…',
  'setup.loadFailed': 'Impossibile caricare i dati di setup.',
  'common.none': 'Nessuno',
  'common.notSet': 'Non impostato',
  'nav.setupSections': 'Sezioni setup',
  // Pressure
  'pressure.tyre': 'Treno di gomme',
  'pressure.outgoing': 'Uscita in pista',
  'pressure.cold': 'a freddo',
  'pressure.incoming': 'Rientro ai box',
  'pressure.hot': 'a caldo',
  'pressure.fl': 'AS',
  'pressure.fr': 'AD',
  'pressure.rl': 'PS',
  'pressure.rr': 'PD',
  // Front
  'front.caster': 'Caster (Incidenza)',
  'front.camber': 'Camber (Campanatura)',
  'front.trackWidth': 'Carreggiata anteriore',
  'front.trackWidthUnit': 'mm',
  'front.rideHeight': 'Altezza anteriore',
  'front.frontHubs': 'Mozzi anteriori',
  'front.ackermann': 'Ackermann',
  'front.inner': 'Interno',
  'front.outer': 'Esterno',
  'front.toeAlignment': 'Convergenza (Toe)',
  'front.torsionBar': 'Barra di torsione',
  'front.hard': 'Dura',
  'front.medium': 'Media',
  'front.soft': 'Morbida',
  // Rear
  'rear.axle': 'Assale',
  'rear.rearWidth': 'Carreggiata posteriore',
  'rear.rearHubs': 'Mozzi posteriori',
  'rear.loosenedBumper': 'Paraurti posteriore allentato',
  // Engine
  'engine.engine': 'Motore',
  'engine.sparkPlug': 'Candela',
  'engine.gearRatio': 'Rapporto di trasmissione',
  'engine.pinion': 'Pignone',
  'engine.crown': 'Corona',
  // Carburetor
  'carb.carburetor': 'Carburatore',
  'carb.mainJet': 'Getto massimo',
  'carb.idleJet': 'Getto minimo',
  'carb.needleClip': 'Tacca spillo',
  'carb.airScrew': 'Vite aria',
  'carb.floatHeight': 'Altezza galleggiante',
  // Chassis
  'chassisSelect.chassis': 'Telaio',
  'chassisSelect.weight': 'Peso',
  // Notes
  'notes.notes': 'Note',
  'notes.placeholder': 'Note sul setup…',

  // Navigation – inventory
  'nav.inventory': 'Inventario',
  'nav.organization': 'Organizzazione',
  'nav.setup': 'Setup',

  // Materials — common
  'common.add': 'Aggiungi',
  'common.save': 'Salva',
  'common.create': 'Crea',
  'common.created': 'Creato',
  'common.edit': 'Modifica',
  'common.delete': 'Elimina',
  'common.optional': '(opzionale)',
  'common.brand': 'Marca',
  'common.type': 'Tipo',
  'materials.profile': 'Profilo',
  'materials.selectProfile': 'Seleziona profilo…',
  'common.nr': 'N°',
  'common.nrInfo': 'Numero progressivo per identificare questo elemento.',
  'common.team': 'Team',
  'common.year': 'Anno',
  'common.stiffness': 'Durezza',
  'common.width': 'Lunghezza',
  'common.position': 'Posizione',

  // Materials — CRUD
  'crud.requiredField': '{field} è obbligatorio',
  'crud.updated': '{entity} aggiornato',
  'crud.created': '{entity} creato',
  'crud.deleted': '{entity} eliminato',
  'crud.confirmDelete': 'Eliminare {entity} "{name}"?\nQuesta azione non può essere annullata.',
  'crud.emptyState': 'Nessun elemento in {title}. Aggiungi il tuo primo {entity} qui sopra.',
  'crud.editEntity': 'Modifica {entity}',
  'crud.newEntity': 'Nuovo {entity}',

  // Materials — general
  'materials.readOnly': 'Sola lettura',
  'materials.selectTeam': 'Seleziona un team per visualizzare l\'inventario.',

  // Materials — tabs
  'materials.tab.engines': 'Motori',
  'materials.tab.tyres': 'Pneumatici',
  'materials.tab.chassis': 'Telai',
  'materials.tab.carburetors': 'Carburatori',
  'materials.tab.axles': 'Assali',
  'materials.tab.hubs': 'Mozzi',
  'materials.tab.spark_plugs': 'Candele',

  // Materials — entities
  'materials.entity.engine': 'Motore',
  'materials.entity.tyre': 'Pneumatico',
  'materials.entity.chassis': 'Telaio',
  'materials.entity.carburetor': 'Carburatore',
  'materials.entity.axle': 'Assale',
  'materials.entity.hub': 'Mozzo',
  'materials.entity.spark_plug': 'Candela',

  // Materials — tyre-specific
  'materials.tyre.compound': 'Mescola',
  'materials.tyre.compound.dry': 'Asciutto (Slick)',
  'materials.tyre.compound.wet': 'Bagnato (Rain)',
  'materials.tyre.discarded': 'Smaltito',

  // Materials — tyre IDs
  'materials.tyreId.title': 'Codici pneumatici',
  'materials.tyreId.fl': 'AS',
  'materials.tyreId.fr': 'AD',
  'materials.tyreId.rl': 'PS',
  'materials.tyreId.rr': 'PD',
  'materials.tyreId.scan': 'Scansiona codice a barre',
  'materials.tyreId.duplicateInSet': 'Codice pneumatico duplicato in questo treno',
  'materials.tyreId.duplicateInOtherSet': 'Il codice {id} è già utilizzato da {tyre}',
  'materials.tyreId.placeholder': 'Scansiona o inserisci codice gomma',
  'materials.tyreId.crossSetInfo': 'Alcuni codici pneumatico sono in conflitto con altri treni di gomme. Premi di nuovo Salva per sovrascrivere.',

  // Materials — hub positions
  'materials.position.front': 'Anteriore',
  'materials.position.rear': 'Posteriore',
  // Setup editing
  'setup.edit': 'Modifica setup',
  'setup.editTitle': 'Modifica setup',
  'setup.save': 'Salva setup',
  'setup.saving': 'Salvataggio…',
  'setup.saved': 'Setup salvato',
  'setup.saveFailed': 'Impossibile salvare il setup',
  'setup.pageTitle': 'Setup attuale',
  'setup.pageSubtitle': 'Configurazione di base per le nuove sessioni importate',
  'setup.editCurrentTitle': 'Modifica setup attuale',
  'setup.noCurrentSetup': 'Nessun setup ancora configurato. Fai clic su "Modifica setup" per iniziare.',
  // Propagation
  'propagation.title': 'Applica modifiche',
  'propagation.subtitle': 'Applica le modifiche del setup ad altre sessioni',
  'propagation.changes': 'Modifiche',
  'propagation.sessions': 'Sessioni',
  'propagation.selectAll': 'Seleziona tutto',
  'propagation.deselectAll': 'Deseleziona tutto',
  'propagation.apply': 'Applica',
  'propagation.applying': 'Applicazione…',
  'propagation.applied': 'Applicato alle sessioni',
  'propagation.skip': 'Salta',
  'propagation.selectAtLeastOne': 'Seleziona almeno una sessione',
  'propagation.noMatching': 'Nessuna sessione corrispondente trovata',
  // Propagation field labels
  'propagation.field.chassis': 'Telaio',
  'propagation.field.weight': 'Peso',
  'propagation.field.engine': 'Motore',
  'propagation.field.tyre': 'Pneumatici',
  'propagation.field.carburetor': 'Carburatore',
  'propagation.field.axle': 'Assale',
  'propagation.field.flOut': 'AS Uscita',
  'propagation.field.frOut': 'AD Uscita',
  'propagation.field.rlOut': 'PS Uscita',
  'propagation.field.rrOut': 'PD Uscita',
  'propagation.field.flIn': 'AS Rientro',
  'propagation.field.frIn': 'AD Rientro',
  'propagation.field.rlIn': 'PS Rientro',
  'propagation.field.rrIn': 'PD Rientro',
  'propagation.field.rearWidth': 'Carreggiata posteriore',
  'propagation.field.frontHubs': 'Mozzi anteriori',
  'propagation.field.rearHubs': 'Mozzi posteriori',
  'propagation.field.rearBumper': 'Paraurti posteriore',
  'propagation.field.caster': 'Caster',
  'propagation.field.camber': 'Camber',
  'propagation.field.trackWidth': 'Carreggiata anteriore',
  'propagation.field.rideHeight': 'Altezza anteriore',
  'propagation.field.ackermann': 'Ackermann',
  'propagation.field.toe': 'Convergenza',
  'propagation.field.torsionBar': 'Barra di torsione',
  'propagation.field.frontSprocket': 'Pignone',
  'propagation.field.rearSprocket': 'Corona',
  'propagation.field.mainJet': 'Getto massimo',
  'propagation.field.idleJet': 'Getto minimo',
  'propagation.field.needleClip': 'Tacca spillo',
  'propagation.field.airScrew': 'Vite aria',
  'propagation.field.floatHeight': 'Altezza galleggiante',
  'propagation.field.notes': 'Note',
  'propagation.field.sparkPlug': 'Candela',
  // Common additions
  'common.yes': 'Sì',
  'common.no': 'No',
  'common.skip': 'Salta',
  'common.applying': 'Applicazione…',

  // Teams
  'nav.teams': 'Team',
  'team.subtitle': 'Gestisci i tuoi team e i membri',
  'team.create': 'Crea team',
  'team.name': 'Nome del team',
  'team.members': 'Membri',
  'team.role.read': 'Lettura',
  'team.role.write': 'Scrittura',
  'team.role.manage': 'Gestione',
  'team.role.owner': 'Proprietario',
  'team.addMember': 'Aggiungi membro',
  'team.removeMember': 'Rimuovi membro',
  'team.leave': 'Abbandona team',
  'team.confirmLeave': 'Sei sicuro di voler abbandonare questo team?',
  'team.cannotLeaveOwner': 'Non puoi abbandonare il team perché ne sei il proprietario.',
  'team.created': 'Team creato',
  'team.memberAdded': 'Membro aggiunto',
  'team.memberRemoved': 'Membro rimosso',
  'team.roleUpdated': 'Ruolo aggiornato',
  'team.renamed': 'Team rinominato',
  'team.empty': 'Nessun team trovato. Creane uno per iniziare.',
  'team.noWriteAccess': 'Non hai accesso in scrittura a questo team.',
  'team.tab.members': 'Membri',
  'team.tab.sharing': 'Condivisione',
  'team.members.searchPlaceholder': 'Cerca membri...',
  'team.sharing.searchPlaceholder': 'Cerca condivisioni...',
  'team.members.searchTitle': 'Cerca membri',
  'team.members.searchSubtitle': 'Filtra i membri per nome, email o ruolo',
  'team.sharing.searchTitle': 'Cerca condivisioni',
  'team.sharing.searchSubtitle': 'Filtra le condivisioni per proprietario o tipo',
  'team.members.field.bareText': '(qualsiasi testo)',
  'team.members.field.bareTextDesc': 'Cerca per nome',
  'team.members.field.name': 'name:',
  'team.members.field.nameDesc': 'Filtra per nome del membro',
  'team.members.field.role': 'role:',
  'team.members.field.roleDesc': 'Filtra per ruolo (read, write, manage)',
  'team.sharing.field.bareText': '(qualsiasi testo)',
  'team.sharing.field.bareTextDesc': 'Cerca il nome del proprietario',
  'team.sharing.field.owner': 'owner:',
  'team.sharing.field.ownerDesc': 'Filtra per proprietario della condivisione',
  'team.sharing.field.type': 'type:',
  'team.sharing.field.typeDesc': 'Filtra per tipo (all, selected)',

  // Lap Diff Analysis
  'analysis.lapdiff.title': 'Confronto giri (Lap Diff)',
  'analysis.lapdiff.desc': 'Sovrapponi due giri ed evidenzia le differenze di velocità, RPM e accelerazione.',
  'lapdiff.selectHint': 'Seleziona esattamente 2 giri da confrontare.',
  'lapdiff.compare': 'Confronta',
  'lapdiff.comparing': 'Confronto in corso…',
  'lapdiff.viewLapA': 'Vedi Giro A',
  'lapdiff.viewLapB': 'Vedi Giro B',
  'lapdiff.tabTime': 'Tempo',
  'lapdiff.tabSpeed': 'Velocità',
  'lapdiff.tabRpm': 'RPM',
  'lapdiff.tabAcceleration': 'Accelerazione',
  'lapdiff.timeChartTitle': 'Tempo perso per posizione in pista',
  'lapdiff.timeGained': 'Tempo guadagnato',
  'lapdiff.timeLost': 'Tempo perso',
  'lapdiff.cumulativeDelta': 'Δt cumulativo',
  'lapdiff.segmentDelta': 'Δt segmento',
  'lapdiff.trackPosition': 'Posizione in pista',
  'lapdiff.avgDiff': 'Diff. media',
  'lapdiff.maxDiff': 'Diff. max',
  'lapdiff.noGpsData': 'Nessun dato GPS disponibile per il confronto.',
  'lapdiff.pctBetter': '% migliore',
  'lapdiff.segmentTime': 'Segmento',
  'lapdiff.fullLap': 'Giro completo',
  'lapdiff.fasterBy': '{lap} più veloce di {time}',
  'lapdiff.equalTime': 'Stesso tempo',
  'lapdiff.clearAnchors': 'Cancella riferimenti',
  'lapdiff.clickToPlace': 'Fai clic sul tracciato per posizionare i riferimenti',
  'lapdiff.segmentRange': 'Segmenti #{start} – #{end}',
  'lapdiff.segmentDetail': 'Segmento #{index}',

  // Aggregation Analysis
  'analysis.aggregation.title': 'Aggregazione',
  'analysis.aggregation.desc': 'Aggrega i punti di frenata, accelerazione e cambiata su più sessioni nella mappa del tracciato.',
  'aggregation.brakingPoints': 'Frenata',
  'aggregation.accelerationPoints': 'Accelerazione',
  'aggregation.upshiftPoints': 'Cambiata (Upshift)',
  'aggregation.top10Title': 'Top 10 giri più veloci',
  'aggregation.noData': 'Nessun punto dati rilevato',
  'aggregation.noDataHint': 'Prova a selezionare sessioni diverse.',
  'aggregation.trackShapeRequired': 'Geometria tracciato richiesta',
  'aggregation.trackShapeRequiredHint': 'È necessaria una geometria ufficiale del tracciato per visualizzare i grafici di aggregazione. Crea la forma del tracciato nell\'editor.',
  'aggregation.sessionSelectionHint': 'Più sessioni vengono incluse, maggiore sarà la qualità e la precisione delle zone aggregate.',
  'aggregation.brakingSegment': 'Zona di frenata',
  'aggregation.accelerationSegment': 'Zona di accelerazione',
  'aggregation.upshiftSegment': 'Zona di cambiata',
  'aggregation.tooltipSamples': ({ count }) => `${count} campioni`,
  'aggregation.tooltipMedian': 'Mediana',
  'aggregation.tooltipSpread': 'Dispersione',
  'aggregation.gpsHeatmap': 'Mappa di calore GPS',
  'aggregation.eventZones': 'Zone eventi',
  'aggregation.heatmapLow': 'Bassa',
  'aggregation.heatmapHigh': 'Alta',
  'aggregation.selectedLapLine': 'Giro selezionato',
  'aggregation.lapsIncluded': '{count} giri',
  'gearshifting.wizardChooseTrack': 'Scegli tracciato',
  'gearshifting.wizardSelect': 'Seleziona sessioni',
  'gearshifting.wizardResults': 'Risultati',
  'gearshifting.analyzingLap': 'Analisi in corso…',

  // Aggregation Diff Analysis
  'analysis.aggregationdiff.title': 'Confronto aggregazioni',
  'analysis.aggregationdiff.desc': 'Confronta due aggregazioni di sessioni per evidenziare le differenze di traiettoria, frenata, accelerazione e cambiata.',
  'aggregationdiff.groupA': 'Gruppo A',
  'aggregationdiff.groupB': 'Gruppo B',
  'aggregationdiff.baseline': 'Riferimento',
  'aggregationdiff.comparison': 'Confronto',
  'aggregationdiff.groupLabelPlaceholder': 'Etichetta personalizzata (es. Mattina Asciutto)',
  'aggregationdiff.loadSavedAggregation': 'Carica da aggregazione salvata…',
  'aggregationdiff.selectHint': 'Seleziona le sessioni per il Gruppo A (Riferimento) e il Gruppo B (Confronto) per evidenziare le differenze di traiettoria, frenata, accelerazione e cambiata.',
  'aggregationdiff.selectHintA': 'Configura il Gruppo A (Riferimento) selezionando un singolo giro o una o più sessioni.',
  'aggregationdiff.selectHintB': 'Configura il Gruppo B (Confronto) selezionando un singolo giro o una o più sessioni da confrontare con il Gruppo A.',
  'aggregationdiff.compare': 'Confronta aggregazioni',
  'aggregationdiff.bestLap': 'Miglior giro',
  'aggregationdiff.medianLap': 'Giro mediano',
  'aggregationdiff.consistency': 'Costanza (σ)',
  'aggregationdiff.lapsAndSessions': '{laps} giri · {sessions} sessioni',
  'aggregationdiff.layerDiffHeatmap': 'Mappa diff. traiettoria',
  'aggregationdiff.layerMedianLines': 'Traiettorie mediane',
  'aggregationdiff.layerEventDiffs': 'Diff. zone eventi',
  'aggregationdiff.hideUnchanged': 'Attenua < 1.5m',
  'aggregationdiff.keyDifferencesTitle': 'Differenze principali',
  'aggregationdiff.keyDifferencesSubtitle': 'Tratti di pista ordinati per differenza di tempo con possibili cause. Fai clic su un tratto per centrarlo sulla mappa.',
  'aggregationdiff.filterAll': 'Tutti',
  'aggregationdiff.filterLine': 'Traiettoria',
  'aggregationdiff.filterBraking': 'Frenata',
  'aggregationdiff.filterAcceleration': 'Accelerazione',
  'aggregationdiff.filterUpshift': 'Cambiata',
  'aggregationdiff.filterTopSpeed': 'Vel. max',
  'aggregationdiff.possibleReasons': 'Possibili cause',
  'aggregationdiff.topSpeedPeak': 'Picco {a} vs {b} km/h',
  'aggregationdiff.laterBy': '{group} {dist}m più tardi',
  'aggregationdiff.earlierBy': '{group} {dist}m prima',
  'aggregationdiff.widerBy': 'Dispersione +{dist}m più ampia',
  'aggregationdiff.tighterBy': 'Dispersione {dist}m più stretta',
  'aggregationdiff.onlyInGroup': 'Solo in {group}',
  'aggregationdiff.lineSeparation': '{dist}m separazione max traiettoria (zona di {len}m)',
  'aggregationdiff.lineOffsetLeft': 'Sinistra +{dist}m',
  'aggregationdiff.lineOffsetRight': 'Destra +{dist}m',
  'aggregationdiff.noSignificantDiffs': 'Nessuna differenza significativa trovata per questo filtro.',
  'aggregationdiff.sharedLine': 'Traiettoria comune',
  'aggregationdiff.clearFocus': 'Cancella selezione',
  'aggregationdiff.avgSpeed': 'Vel. media',
  'aggregationdiff.speedDiff': 'Diff. velocità',
  'aggregationdiff.lineOffset': 'Scostamento traiettoria',
  'aggregationdiff.layerFasterSegments': 'Segmenti più veloci',
  'aggregationdiff.fasterSegmentLegend': 'Segmento più veloce (Velocità)',
  'aggregationdiff.estTimeGained': '{group} più veloce di {time}',
  'aggregationdiff.estTimeLost': '{group} più veloce di {time}',
  'aggregationdiff.estTimeNeutral': 'Stim. ±0.00s',

  // Analysis History
  'analysis.history.title': 'Cronologia analisi',
  'analysis.history.subtitle': 'Riapri e gestisci le analisi di telemetria valutate in precedenza',
  'analysis.history.filterAll': 'Tutti gli strumenti',
  'analysis.history.filterSector': 'Settori',
  'analysis.history.filterCorner': 'Curve',
  'analysis.history.filterBraking': 'Frenata',
  'analysis.history.filterLapDiff': 'Diff. giri',
  'analysis.history.filterAggregation': 'Aggregazione',
  'analysis.history.filterAggregationDiff': 'Diff. aggregazione',
  'analysis.history.groupsScope': '{a} vs {b} sessione/i',
  'analysis.history.empty': 'Nessuna analisi salvata trovata',
  'analysis.history.emptyDesc': 'Le analisi eseguite dopo aver effettuato l\'accesso appariranno automaticamente qui.',
  'analysis.history.open': 'Apri',
  'analysis.history.rename': 'Rinomina',
  'analysis.history.delete': 'Elimina',
  'analysis.history.deleteConfirm': 'Sei sicuro di voler eliminare questa analisi dalla cronologia?',
  'analysis.history.deleteSuccess': 'Analisi eliminata',
  'analysis.history.renameSuccess': 'Analisi rinominata',
  'analysis.history.searchPlaceholder': 'Cerca nella cronologia analisi...',
  'analysis.history.loading': 'Caricamento analisi...',
  'analysis.history.table.type': 'Tipo',
  'analysis.history.table.name': 'Nome',
  'analysis.history.table.track': 'Tracciato',
  'analysis.history.table.scope': 'Ambito',
  'analysis.history.table.created': 'Creata il',
  'analysis.history.table.actions': 'Azioni',
  'analysis.history.total': '{n} in totale',
  'analysis.history.sessionsCount': '{n} sessione/i',
  'analysis.history.lapsCount': '{n} giro/i',
  'analysis.history.viewAll': 'Vedi cronologia completa',
  'analysis.sessionRemoved.title': 'Sessione rimossa',
  'analysis.sessionRemoved.description': 'La sessione di telemetria utilizzata da questa analisi è stata eliminata e questa analisi non può più essere aperta.',
  'analysis.sessionRemoved.deleteAnalysis': 'Elimina analisi',
  'analysis.sessionRemoved.close': 'Chiudi',

  /* ── Footer ──── */
  'footer.contact': 'Contatti',
  'footer.privacyPolicy': 'Informativa sulla Privacy',
  'footer.reportBug': 'Segnala un bug',
  'footer.bugReportTitle': 'Segnala un bug',
  'footer.description': 'Descrizione',
  'footer.descriptionPlaceholder': 'Descrivi il problema riscontrato...',
  'footer.submit': 'Invia',
  'footer.submitting': 'Invio in corso...',
  'footer.submitted': 'Segnalazione inviata. Grazie!',
  'footer.submitFailed': 'Impossibile inviare la segnalazione di bug.',

  /* ── Error auto-reporting & Error Boundary ─────────────────────────── */
  'error.autoReported': 'Si è verificato un errore che è stato segnalato automaticamente.',
  'errorBoundary.title': 'Qualcosa è andato storto',
  'errorBoundary.message': 'Si è verificato un errore imprevisto che è stato segnalato al server.',
  'errorBoundary.reload': 'Ricarica pagina',
  'errorBoundary.reset': 'Riprova',
  'errorBoundary.showDetails': 'Mostra dettagli errore',
  'errorBoundary.hideDetails': 'Nascondi dettagli errore',

  /* ── Setup Coach ──────────────────────────────────────────── */
  'coach.title': 'Setup Coach',
  'coach.subtitle': 'Una guida alle regolazioni del setup del kart organizzata per obiettivo di guida. Seleziona un comportamento per vedere le modifiche consigliate e i relativi effetti.',
  'coach.disclaimer': 'Queste raccomandazioni sono linee guida generali per kart Rotax Max. Prova sempre le modifiche un passo alla volta e adattale in base alle condizioni della pista, al feedback del pilota e allo stato degli pneumatici.',
  'coach.col.parameter': 'Parametro',
  'coach.col.change': 'Modifica',
  'coach.col.effect': 'Effetto',
  'coach.col.sideEffects': 'Effetti collaterali',
  'coach.col.effectiveness': 'Efficacia',

  // Reduce Understeer
  'coach.goal.understeer.title': 'Ridurre il sottosterzo',
  'coach.goal.understeer.desc': 'Il kart allarga la traiettoria in curva e non segue la linea impostata. Le gomme anteriori perdono aderenza prima di quelle posteriori, rendendo l\'avantreno poco reattivo agli input dello sterzo.',
  'coach.goal.understeer.adj1.param': 'Carreggiata anteriore',
  'coach.goal.understeer.adj1.change': 'Allargare',
  'coach.goal.understeer.adj1.effect': 'Più grip meccanico all\'anteriore',
  'coach.goal.understeer.adj1.side': 'Può rendere l\'avantreno più aggressivo',
  'coach.goal.understeer.adj2.param': 'Caster anteriore',
  'coach.goal.understeer.adj2.change': 'Aumentare',
  'coach.goal.understeer.adj2.effect': 'Più inserimento all\'anteriore in ingresso curva',
  'coach.goal.understeer.adj2.side': 'Minore stabilità in rettilineo',
  'coach.goal.understeer.adj3.param': 'Camber anteriore',
  'coach.goal.understeer.adj3.change': 'Aggiungere (più negativo)',
  'coach.goal.understeer.adj3.effect': 'Più grip anteriore a centro curva',
  'coach.goal.understeer.adj3.side': 'Usura irregolare degli pneumatici',
  'coach.goal.understeer.adj4.param': 'Altezza anteriore',
  'coach.goal.understeer.adj4.change': 'Abbassare',
  'coach.goal.understeer.adj4.effect': 'Baricentro più basso, più grip',
  'coach.goal.understeer.adj4.side': 'Rischio di toccare il fondo sui cordoli',
  'coach.goal.understeer.adj5.param': 'Assale posteriore',
  'coach.goal.understeer.adj5.change': 'Più morbido (meno rigido)',
  'coach.goal.understeer.adj5.effect': 'Libera il posteriore aiutando la rotazione',
  'coach.goal.understeer.adj5.side': 'Può causare instabilità al posteriore',
  'coach.goal.understeer.adj6.param': 'Pressione gomme anteriori',
  'coach.goal.understeer.adj6.change': 'Aumentare leggermente',
  'coach.goal.understeer.adj6.effect': 'Risposta anteriore più pronta',
  'coach.goal.understeer.adj6.side': 'Impronta a terra ridotta',

  // Reduce Oversteer
  'coach.goal.oversteer.title': 'Ridurre il sovrasterzo',
  'coach.goal.oversteer.desc': 'Il posteriore del kart scivola in curva facendo ruotare il mezzo in modo troppo brusco. Le gomme posteriori perdono aderenza prima di quelle anteriori, causando sovrasterzo improvviso o un retrotreno instabile.',
  'coach.goal.oversteer.adj1.param': 'Carreggiata anteriore',
  'coach.goal.oversteer.adj1.change': 'Stringere',
  'coach.goal.oversteer.adj1.effect': 'Meno grip anteriore, bilancia il telaio',
  'coach.goal.oversteer.adj1.side': 'Minore prontezza di sterzo',
  'coach.goal.oversteer.adj2.param': 'Caster anteriore',
  'coach.goal.oversteer.adj2.change': 'Ridurre',
  'coach.goal.oversteer.adj2.effect': 'Meno grip all\'anteriore',
  'coach.goal.oversteer.adj2.side': 'Inserimento più lento',
  'coach.goal.oversteer.adj3.param': 'Assale posteriore',
  'coach.goal.oversteer.adj3.change': 'Irrigidire (più duro)',
  'coach.goal.oversteer.adj3.effect': 'Più grip al posteriore',
  'coach.goal.oversteer.adj3.side': 'Il telaio può saltellare sulle sconnessioni',
  'coach.goal.oversteer.adj4.param': 'Carreggiata posteriore',
  'coach.goal.oversteer.adj4.change': 'Allargare',
  'coach.goal.oversteer.adj4.effect': 'Più grip meccanico laterale al posteriore',
  'coach.goal.oversteer.adj4.side': 'Minore rotazione del posteriore',
  'coach.goal.oversteer.adj5.param': 'Pressione gomme posteriori',
  'coach.goal.oversteer.adj5.change': 'Ridurre leggermente',
  'coach.goal.oversteer.adj5.effect': 'Maggiore impronta a terra posteriore',
  'coach.goal.oversteer.adj5.side': 'Riscaldamento gomme più lento',
  'coach.goal.oversteer.adj6.param': 'Barra di torsione anteriore',
  'coach.goal.oversteer.adj6.change': 'Aggiungere',
  'coach.goal.oversteer.adj6.effect': 'Irrigidisce l\'avantreno, riduce il grip anteriore',
  'coach.goal.oversteer.adj6.side': 'Minore flessibilità anteriore',

  // Chassis Bounce
  'coach.goal.bounce.title': 'Il telaio saltella in curva',
  'coach.goal.bounce.desc': 'Il telaio saltella a centro curva invece di mantenere un contatto fluido con l\'asfalto. Questo fenomeno è solitamente causato da un telaio troppo rigido rispetto al livello di grip in pista, rendendo impossibile mantenere una velocità di percorrenza costante.',
  'coach.goal.bounce.adj1.param': 'Assale posteriore',
  'coach.goal.bounce.adj1.change': 'Più morbido (meno rigido)',
  'coach.goal.bounce.adj1.effect': 'Assorbe energia e rende il passaggio più fluido',
  'coach.goal.bounce.adj1.side': 'Può ridurre il grip posteriore',
  'coach.goal.bounce.adj2.param': 'Carreggiata posteriore',
  'coach.goal.bounce.adj2.change': 'Allargare',
  'coach.goal.bounce.adj2.effect': 'Stabilizza il telaio a centro curva',
  'coach.goal.bounce.adj2.side': 'Minore rotazione in uscita',
  'coach.goal.bounce.adj3.param': 'Paraurti posteriore',
  'coach.goal.bounce.adj3.change': 'Allentare',
  'coach.goal.bounce.adj3.effect': 'Aumenta la flessione del telaio e assorbe le vibrazioni',
  'coach.goal.bounce.adj3.side': 'Supporto meno rigido',
  'coach.goal.bounce.adj4.param': 'Pressione gomme posteriori',
  'coach.goal.bounce.adj4.change': 'Ridurre',
  'coach.goal.bounce.adj4.effect': 'Maggiore assorbimento sulle asperità',
  'coach.goal.bounce.adj4.side': 'Risposta più lenta',
  'coach.goal.bounce.adj5.param': 'Altezza anteriore',
  'coach.goal.bounce.adj5.change': 'Alzare',
  'coach.goal.bounce.adj5.effect': 'Maggiore luce da terra del telaio',
  'coach.goal.bounce.adj5.side': 'Meno grip anteriore',

  // Reduce Front Aggressiveness
  'coach.goal.frontAggressive.title': 'Ridurre l\'aggressività dell\'avantreno',
  'coach.goal.frontAggressive.desc': 'L\'avantreno ha troppo mordente, facendo inserire il kart in modo troppo brusco e scomponendo il posteriore. Il kart risulta nervoso in ingresso curva e può innescare un sovrasterzo improvviso.',
  'coach.goal.frontAggressive.adj1.param': 'Carreggiata anteriore',
  'coach.goal.frontAggressive.adj1.change': 'Stringere',
  'coach.goal.frontAggressive.adj1.effect': 'Riduce il grip anteriore',
  'coach.goal.frontAggressive.adj1.side': 'Maggiore tendenza al sottosterzo',
  'coach.goal.frontAggressive.adj2.param': 'Caster anteriore',
  'coach.goal.frontAggressive.adj2.change': 'Ridurre',
  'coach.goal.frontAggressive.adj2.effect': 'Meno mordente in fase di inserimento',
  'coach.goal.frontAggressive.adj2.side': 'Inserimento più lento',
  'coach.goal.frontAggressive.adj3.param': 'Barra di torsione anteriore',
  'coach.goal.frontAggressive.adj3.change': 'Rimuovere o ammorbidire',
  'coach.goal.frontAggressive.adj3.effect': 'Ammorbidisce l\'avantreno',
  'coach.goal.frontAggressive.adj3.side': 'L\'avantreno può perdere precisione',
  'coach.goal.frontAggressive.adj4.param': 'Camber anteriore',
  'coach.goal.frontAggressive.adj4.change': 'Ridurre (meno negativo)',
  'coach.goal.frontAggressive.adj4.effect': 'Meno grip in percorrenza',
  'coach.goal.frontAggressive.adj4.side': 'Usura gomme più uniforme',
  'coach.goal.frontAggressive.adj5.param': 'Pressione gomme anteriori',
  'coach.goal.frontAggressive.adj5.change': 'Aumentare',
  'coach.goal.frontAggressive.adj5.effect': 'Impronta a terra più piccola',
  'coach.goal.frontAggressive.adj5.side': 'Più reattivo ma con meno grip totale',

  // Reduce Rear Sliding
  'coach.goal.rearSlide.title': 'Ridurre lo scivolamento del posteriore',
  'coach.goal.rearSlide.desc': 'Il posteriore del kart scivola eccessivamente in percorrenza di curva, causando perdita di tempo e usura anomala delle gomme. Il kart manca di tenuta posteriore e appare instabile sotto carico laterale.',
  'coach.goal.rearSlide.adj1.param': 'Assale posteriore',
  'coach.goal.rearSlide.adj1.change': 'Irrigidire (più duro)',
  'coach.goal.rearSlide.adj1.effect': 'Più grip al posteriore',
  'coach.goal.rearSlide.adj1.side': 'Può saltellare sulle sconnessioni',
  'coach.goal.rearSlide.adj2.param': 'Carreggiata posteriore',
  'coach.goal.rearSlide.adj2.change': 'Allargare',
  'coach.goal.rearSlide.adj2.effect': 'Più grip meccanico posteriore',
  'coach.goal.rearSlide.adj2.side': 'Rotazione meno libera',
  'coach.goal.rearSlide.adj3.param': 'Pressione gomme posteriori',
  'coach.goal.rearSlide.adj3.change': 'Aumentare leggermente',
  'coach.goal.rearSlide.adj3.effect': 'Migliore sostegno della spalla sotto carico',
  'coach.goal.rearSlide.adj3.side': 'Impronta a terra ridotta al limite',
  'coach.goal.rearSlide.adj4.param': 'Carreggiata anteriore',
  'coach.goal.rearSlide.adj4.change': 'Stringere',
  'coach.goal.rearSlide.adj4.effect': 'Riequilibra la distribuzione del grip',
  'coach.goal.rearSlide.adj4.side': 'Meno mordente all\'anteriore',
  'coach.goal.rearSlide.adj5.param': 'Mozzi posteriori',
  'coach.goal.rearSlide.adj5.change': 'Usare mozzi più lunghi',
  'coach.goal.rearSlide.adj5.effect': 'Maggiore leva sull\'assale posteriore',
  'coach.goal.rearSlide.adj5.side': 'Sterzo più pesante',

  // Corner Exit Traction
  'coach.goal.cornerExit.title': 'Migliorare la trazione in uscita di curva',
  'coach.goal.cornerExit.desc': 'Il kart fatica a scaricare la potenza a terra in uscita di curva, con le gomme posteriori che pattinano o scivolano accelerando fuori dalle curve lente, causando perdita di tempo nel lancio sul rettilineo.',
  'coach.goal.cornerExit.adj1.param': 'Carreggiata posteriore',
  'coach.goal.cornerExit.adj1.change': 'Allargare',
  'coach.goal.cornerExit.adj1.effect': 'Più grip meccanico in uscita',
  'coach.goal.cornerExit.adj1.side': 'Minore rotazione a centro curva',
  'coach.goal.cornerExit.adj2.param': 'Assale posteriore',
  'coach.goal.cornerExit.adj2.change': 'Irrigidire (più duro)',
  'coach.goal.cornerExit.adj2.effect': 'Pianta il posteriore in accelerazione',
  'coach.goal.cornerExit.adj2.side': 'Può saltellare sotto carico',
  'coach.goal.cornerExit.adj3.param': 'Pressione gomme posteriori',
  'coach.goal.cornerExit.adj3.change': 'Abbassare',
  'coach.goal.cornerExit.adj3.effect': 'Maggiore impronta a terra in uscita',
  'coach.goal.cornerExit.adj3.side': 'Riscaldamento gomme più lento',
  'coach.goal.cornerExit.adj4.param': 'Corona posteriore',
  'coach.goal.cornerExit.adj4.change': 'Aumentare (più denti)',
  'coach.goal.cornerExit.adj4.effect': 'Più spunto ai bassi regimi',
  'coach.goal.cornerExit.adj4.side': 'Velocità di punta inferiore',
  'coach.goal.cornerExit.adj5.param': 'Paraurti posteriore',
  'coach.goal.cornerExit.adj5.change': 'Allentare',
  'coach.goal.cornerExit.adj5.effect': 'Maggiore flessione sotto carico',
  'coach.goal.cornerExit.adj5.side': 'Risposta meno prevedibile',

  // Hot Conditions
  'coach.goal.hotConditions.title': 'Adattarsi a condizioni di caldo elevato',
  'coach.goal.hotConditions.desc': 'La temperatura dell\'asfalto è elevata, aumentando il grip della pista e il surriscaldamento delle gomme. Il telaio può risultare "incollato", portando a saltellamenti o eccessiva aggressività anteriore. Il motore lavora a temperature più alte.',
  'coach.goal.hotConditions.adj1.param': 'Tutte le pressioni gomme',
  'coach.goal.hotConditions.adj1.change': 'Aumentare',
  'coach.goal.hotConditions.adj1.effect': 'Compensa l\'espansione termica',
  'coach.goal.hotConditions.adj1.side': 'Può ridurre il grip se eccessiva',
  'coach.goal.hotConditions.adj2.param': 'Getto massimo',
  'coach.goal.hotConditions.adj2.change': 'Ingrassare (numero più grande)',
  'coach.goal.hotConditions.adj2.effect': 'Previene smagrimenti pericolosi',
  'coach.goal.hotConditions.adj2.side': 'Leggera perdita di potenza',
  'coach.goal.hotConditions.adj3.param': 'Assale posteriore',
  'coach.goal.hotConditions.adj3.change': 'Ammorbidire',
  'coach.goal.hotConditions.adj3.effect': 'Compensa l\'aumento di grip della pista',
  'coach.goal.hotConditions.adj3.side': 'Può dare sensazione di posteriore leggero',
  'coach.goal.hotConditions.adj4.param': 'Carreggiata posteriore',
  'coach.goal.hotConditions.adj4.change': 'Stringere leggermente',
  'coach.goal.hotConditions.adj4.effect': 'Riduce il grip posteriore in eccesso',
  'coach.goal.hotConditions.adj4.side': 'Meno trazione in uscita',
  'coach.goal.hotConditions.adj5.param': 'Vite aria',
  'coach.goal.hotConditions.adj5.change': 'Aprire (svitare di più)',
  'coach.goal.hotConditions.adj5.effect': 'Miscela al minimo più ricca',
  'coach.goal.hotConditions.adj5.side': 'Può influire sulla pulizia ai bassi',

  // Cold/Wet Conditions
  'coach.goal.coldConditions.title': 'Adattarsi a condizioni di freddo / bagnato',
  'coach.goal.coldConditions.desc': 'La temperatura dell\'asfalto è bassa o la pista è bagnata, riducendo drasticamente il grip. Il kart necessita del massimo grip meccanico e la carburazione deve compensare l\'aria più densa. Effettua modifiche prudenti dando priorità alla sicurezza.',
  'coach.goal.coldConditions.adj1.param': 'Tutte le pressioni gomme',
  'coach.goal.coldConditions.adj1.change': 'Ridurre',
  'coach.goal.coldConditions.adj1.effect': 'Compensa la contrazione dovuta al freddo',
  'coach.goal.coldConditions.adj1.side': 'Rischio di stallonamento sul cerchio',
  'coach.goal.coldConditions.adj2.param': 'Getto massimo',
  'coach.goal.coldConditions.adj2.change': 'Smagrire (numero più piccolo)',
  'coach.goal.coldConditions.adj2.effect': 'Compensa la maggiore densità dell\'aria',
  'coach.goal.coldConditions.adj2.side': 'Rischio di surriscaldamento/grippaggio motore',
  'coach.goal.coldConditions.adj3.param': 'Assale posteriore',
  'coach.goal.coldConditions.adj3.change': 'Irrigidire (più duro)',
  'coach.goal.coldConditions.adj3.effect': 'Genera più grip meccanico',
  'coach.goal.coldConditions.adj3.side': 'Può saltellare sul bagnato',
  'coach.goal.coldConditions.adj4.param': 'Carreggiata ant. e post.',
  'coach.goal.coldConditions.adj4.change': 'Allargare entrambe',
  'coach.goal.coldConditions.adj4.effect': 'Massimizza il grip meccanico',
  'coach.goal.coldConditions.adj4.side': 'Guida più reattiva e impegnativa',
  'coach.goal.coldConditions.adj5.param': 'Vite aria',
  'coach.goal.coldConditions.adj5.change': 'Chiudere (avvitare)',
  'coach.goal.coldConditions.adj5.effect': 'Miscela al minimo più magra',
  'coach.goal.coldConditions.adj5.side': 'Può influire sull\'avviamento a freddo',

  // Braking Stability
  'coach.goal.braking.title': 'Migliorare la stabilità in frenata',
  'coach.goal.braking.desc': 'Il kart si scompone in staccata, con il posteriore che scoda o le ruote che bloccano. Questo rende difficile staccare tardi con costanza, facendo perdere tempo prezioso in ingresso curva.',
  'coach.goal.braking.adj1.param': 'Pressione gomme anteriori',
  'coach.goal.braking.adj1.change': 'Aumentare',
  'coach.goal.braking.adj1.effect': 'Avantreno più preciso in staccata',
  'coach.goal.braking.adj1.side': 'Impronta a terra in frenata ridotta',
  'coach.goal.braking.adj2.param': 'Caster anteriore',
  'coach.goal.braking.adj2.change': 'Aumentare',
  'coach.goal.braking.adj2.effect': 'Più avancorsa, stabilizza in staccata',
  'coach.goal.braking.adj2.side': 'Sterzo più pesante',
  'coach.goal.braking.adj3.param': 'Altezza anteriore',
  'coach.goal.braking.adj3.change': 'Abbassare',
  'coach.goal.braking.adj3.effect': 'Migliore trasferimento di carico anteriore',
  'coach.goal.braking.adj3.side': 'Rischio di toccare con il telaio',
  'coach.goal.braking.adj4.param': 'Barra di torsione anteriore',
  'coach.goal.braking.adj4.change': 'Aggiungere',
  'coach.goal.braking.adj4.effect': 'Irrigidisce l\'avantreno in staccata',
  'coach.goal.braking.adj4.side': 'Può ridurre il grip in inserimento',
  'coach.goal.braking.adj5.param': 'Pressione gomme posteriori',
  'coach.goal.braking.adj5.change': 'Ridurre',
  'coach.goal.braking.adj5.effect': 'Previene il bloccaggio dell\'assale posteriore',
  'coach.goal.braking.adj5.side': 'Risposta posteriore più lenta',

  // Engine Tuning
  'coach.goal.engine.title': 'Ottimizzare le prestazioni del motore',
  'coach.goal.engine.desc': 'Ottimizza la resa del motore tramite rapporti di trasmissione e carburazione. Queste regolazioni influenzano erogazione, accelerazione, velocità massima e affidabilità. Controlla sempre la temperatura gas di scarico (EGT) quando modifichi la carburazione.',
  'coach.goal.engine.adj1.param': 'Corona posteriore',
  'coach.goal.engine.adj1.change': 'Aumentare (più denti)',
  'coach.goal.engine.adj1.effect': 'Più accelerazione, minore velocità di punta',
  'coach.goal.engine.adj1.side': 'RPM più elevati in rettilineo',
  'coach.goal.engine.adj2.param': 'Corona posteriore',
  'coach.goal.engine.adj2.change': 'Ridurre (meno denti)',
  'coach.goal.engine.adj2.effect': 'Maggiore velocità di punta, meno accelerazione',
  'coach.goal.engine.adj2.side': 'RPM più bassi, uscite di curva più lente',
  'coach.goal.engine.adj3.param': 'Getto massimo',
  'coach.goal.engine.adj3.change': 'Ingrassare (numero più grande)',
  'coach.goal.engine.adj3.effect': 'EGT più bassa, maggiore sicurezza motore',
  'coach.goal.engine.adj3.side': 'Leggera perdita di potenza agli alti',
  'coach.goal.engine.adj4.param': 'Getto massimo',
  'coach.goal.engine.adj4.change': 'Smagrire (numero più piccolo)',
  'coach.goal.engine.adj4.effect': 'Più potenza e allungo',
  'coach.goal.engine.adj4.side': 'Rischio di grippaggio, EGT più alta',
  'coach.goal.engine.adj5.param': 'Tacca spillo',
  'coach.goal.engine.adj5.change': 'Alzare la clip (abbassare lo spillo)',
  'coach.goal.engine.adj5.effect': 'Smagrisce ai medi regimi, risposta più pronta',
  'coach.goal.engine.adj5.side': 'Rischio di vuoto o carburazione magra ai medi',
  'coach.goal.engine.adj6.param': 'Altezza galleggiante',
  'coach.goal.engine.adj6.change': 'Regolare',
  'coach.goal.engine.adj6.effect': 'Controlla il livello del carburante nella vaschetta',
  'coach.goal.engine.adj6.side': 'Influenza l\'intero arco di erogazione',

  // Track Map Controls
  'trackMap.zoomIn': 'Ingrandisci',
  'trackMap.zoomOut': 'Riduci',
  'trackMap.fitTrack': 'Adatta al tracciato',
  'trackMap.satellite': 'Satellite',
  'trackMap.vector': 'Vettoriale',
  'trackMap.switchProvider': 'Cambia fornitore immagini aeree',

  // Lap Analysis Queue & Amended Analysis
  'queue.processingLaps': 'Analisi giri {done}/{total}',
  'queue.completed': 'Analisi giri completata ({total}/{total})',
  'tracks.reanalyzeLaps': 'Rianalizza giri',
  'tracks.reanalyzingLaps': 'Messa in coda…',
  'tracks.reanalyzeQueued': '{enqueued} giro/i messo/i in coda per l\'analisi ({skipped} già aggiornato/i).',
  'tracks.reanalyzeAllUpToDate': 'Tutti i {skipped} giri sono già aggiornati con i dati attuali del tracciato.',
  'lapInfo.canonicalSectors': 'Settori tracciato',
  'lapInfo.loggerSectors': 'Settori acquisitore',
  'lapAnalysis.amendedCornersTitle': 'Dettaglio curve e frenate',
  'lapAnalysis.cornerCol': 'Curva',
  'lapAnalysis.topApproachSpeed': 'Vel. max prima della staccata',
  'lapAnalysis.slowestSpeed': 'Velocità minima',
  'lapAnalysis.apexSpeed': 'Velocità alla corda',
  'lapAnalysis.exitSpeed': 'Velocità di uscita',
  'lapAnalysis.brakingDist': 'Spazio frenata',
  'lapAnalysis.cornerTime': 'Durata',
  'lapAnalysis.statusCompleted': 'Analisi completata',
  'lapAnalysis.statusPending': 'Analisi in attesa',
  'session.tabCorners': 'Curve',
  'session.noCornersConfigured': 'Nessun dato di analisi curve disponibile per questa sessione.',
  'lapAnalysis.entrySpeed': 'Velocità di ingresso',
  'lapAnalysis.trailBraking': 'Trail Braking',

  // Terms & Conditions
  'footer.termsAndConditions': 'Termini e Condizioni',
  'terms.gateTitle': 'Termini e Condizioni',
  'terms.gateSubtitle': 'Esamina e accetta gli ultimi Termini e Condizioni per continuare.',
  'terms.updatedBannerTitle': 'Termini e Condizioni aggiornati:',
  'terms.updatedBannerDesc': 'I nostri Termini e Condizioni sono stati aggiornati. Esamina e accetta la nuova versione per continuare a usare kart.win.',
  'terms.checkboxLabel': 'Ho letto e accetto i Termini e Condizioni',
  'terms.acceptButton': 'Accetta e continua',
  'terms.acceptingButton': 'Accettazione…',
  'terms.loadError': 'Impossibile caricare i Termini e Condizioni. Controlla la connessione e riprova.',
  'terms.acceptError': 'Impossibile registrare la tua accettazione. Riprova.',

  // Additional Common & Import Keys
  'common.previous': 'Precedente',
  'common.remove': 'Rimuovi',
  'common.success': 'Salvato correttamente',
  'common.failedToSave': 'Salvataggio non riuscito',
  'import.useCurrentSetupDesc': 'Associa il setup attivo del kart alle sessioni importate.',

  // Search & Filter Bar
  'search.booleanLogicUse': 'Combina i termini con',
  'search.booleanLogicOr': 'oppure',
  'search.booleanLogicGroup': 'e raggruppa le espressioni con le parentesi',
  'filter.operator.eq': 'è',
  'filter.operator.neq': 'non è',
  'filter.operator.gt': 'maggiore di',
  'filter.operator.gte': 'almeno',
  'filter.operator.lt': 'minore di',
  'filter.operator.lte': 'al massimo',
  'filter.operator.range': 'tra',
  'filter.operator.contains': 'contiene',
  'filter.remove': 'Rimuovi filtro',
  'filter.done': 'Fatto',
  'filter.clearInput': 'Cancella testo',
  'filter.selectField': 'Filtra per campo',
  'filter.pressEnter': 'Premi Invio per applicare',
  'filter.selectValues': 'Seleziona valori',
  'filter.noMatchingOptions': 'Nessuna opzione corrispondente',

  // Search Schemas
  'filter.session.bareSearchExample': 'Cerca per nome del tracciato',
  'filter.session.searchTrack': 'Filtra per nome del tracciato',
  'filter.session.filterLaps': 'Filtra per numero totale di giri',
  'filter.session.filterBestTime': 'Filtra per miglior tempo sul giro (secondi)',
  'filter.session.filterMaxSpeed': 'Filtra per velocità massima (km/h)',
  'filter.session.filterMaxRpm': 'Filtra per regime massimo del motore',
  'filter.session.filterDate': 'Filtra per data della sessione',
  'filter.session.filterShared': 'Filtra per stato di condivisione nel team',
  'filter.session.filterVisibility': 'Filtra per proprietà o visibilità del team',
  'filter.session.visibilityMine': 'Le mie sessioni',
  'filter.session.visibilityShared': 'Condivise con il team',
  'filter.session.exampleTrackLaps': 'Sessioni a Lonato con 10+ giri',
  'filter.session.exampleBestSpeed': 'Giri veloci con alta velocità di punta',

  'filter.analysis.bareSearchExample': 'Cerca per titolo analisi o nome del tracciato',
  'filter.analysis.searchTitle': 'Filtra per titolo dell’analisi',
  'filter.analysis.searchTrack': 'Filtra per nome del tracciato',
  'filter.analysis.filterType': 'Filtra per tipo di analisi',
  'filter.analysis.filterDate': 'Filtra per data di creazione',
  'filter.analysis.filterShared': 'Filtra per stato di condivisione nel team',
  'filter.analysis.filterVisibility': 'Filtra per proprietà o condivisione nel team',
  'filter.analysis.exampleCornerTrack': 'Analisi curve a Lonato',
  'filter.analysis.exampleSharedDate': 'Analisi condivise del 2026',

  'filter.trackRaces.bareSearchExample': 'Cerca per titolo evento, stagione o categoria',
  'filter.trackRaces.searchTitle': 'Filtra per titolo evento',
  'filter.trackRaces.searchSeason': 'Filtra per stagione di campionato',
  'filter.trackRaces.searchCategory': 'Filtra per categoria',
  'filter.trackRaces.filterRound': 'Filtra per numero di round',
  'filter.trackRaces.filterDate': 'Filtra per data evento',
  'filter.trackRaces.exampleCatDate': 'Eventi ROK Mini nel 2026',
  'filter.trackRaces.exampleSeasonRound': 'Primi due round della ROK Cup',

  'filter.tracks.bareSearchExample': 'Cerca per nome del tracciato o paese',
  'filter.tracks.searchName': 'Filtra per nome del tracciato',
  'filter.tracks.searchCountry': 'Filtra per codice paese',
  'filter.tracks.filterType': 'Filtra per origine del tracciato (ufficiale o rilevato)',
  'filter.tracks.filterSessions': 'Filtra per numero di sessioni registrate',
  'filter.tracks.filterLaps': 'Filtra per numero di giri registrati',
  'filter.tracks.filterEvents': 'Filtra per numero di eventi ufficiali',
  'filter.tracks.filterDrivers': 'Filtra per numero di piloti ufficiali',
  'filter.tracks.exampleItSessions': 'Tracciati italiani con sessioni registrate',
  'filter.tracks.exampleOfficialEvents': 'Circuiti ufficiali con 3+ eventi',

  'filter.leaderboard.bareSearchExample': 'Cerca per pilota, categoria, stagione o evento',
  'filter.leaderboard.searchDriver': 'Filtra per nome pilota',
  'filter.leaderboard.searchCategory': 'Filtra per categoria',
  'filter.leaderboard.searchSeason': 'Filtra per stagione di campionato',
  'filter.leaderboard.searchEvent': 'Filtra per nome evento',
  'filter.leaderboard.filterLapTime': 'Filtra per tempo sul giro (secondi)',
  'filter.leaderboard.filterSpeed': 'Filtra per velocità di punta (km/h)',
  'filter.leaderboard.filterRpm': 'Filtra per RPM massimi',
  'filter.leaderboard.filterDate': 'Filtra per data del giro',
  'filter.leaderboard.exampleTimeSpeed': 'Giri sotto 48s con alta velocità di punta',
  'filter.leaderboard.exampleCatTime': 'Giri categoria Mini tra 52s e 54s',

  'filter.tyres.bareSearchExample': 'Cerca per nome set, marca, modello o codice a barre',
  'filter.tyres.searchName': 'Filtra per nome del set di gomme',
  'filter.tyres.searchBrand': 'Filtra per marca di gomme',
  'filter.tyres.searchModel': 'Filtra per mescola/modello',
  'filter.tyres.searchSize': 'Filtra per misura',
  'filter.tyres.searchBarcode': 'Filtra per codice a barre scansionato',
  'filter.tyres.filterStatus': 'Filtra per stato del ciclo di vita',
  'filter.tyres.filterCondition': 'Filtra per stato residuo (%)',
  'filter.tyres.filterLaps': 'Filtra per giri totali percorsi',
  'filter.tyres.filterDistance': 'Filtra per distanza totale percorsa (km)',
  'filter.tyres.exampleActiveBrand': 'Set di gomme LeCont attivi',
  'filter.tyres.exampleConditionLaps': 'Gomme con >50% di vita e <30 giri',

  'filter.teamMembers.bareSearchExample': 'Cerca per nome o email del membro',
  'filter.teamMembers.searchName': 'Filtra per nome del membro',
  'filter.teamMembers.searchEmail': 'Filtra per email del membro',
  'filter.teamMembers.filterRole': 'Filtra per ruolo nel team',
  'filter.teamMembers.exampleRoleAdmin': 'Amministratori del team',
  'filter.teamMembers.exampleNameRole': 'Membri o editor per nome',

  'filter.teamSharing.bareSearchExample': 'Cerca per titolo, proprietario o tracciato',
  'filter.teamSharing.searchTitle': 'Filtra per titolo dell’elemento',
  'filter.teamSharing.searchOwner': 'Filtra per nome del proprietario',
  'filter.teamSharing.searchTrack': 'Filtra per nome del tracciato',
  'filter.teamSharing.filterKind': 'Filtra per tipo di elemento condiviso',
  'filter.teamSharing.kindSession': 'Sessione',
  'filter.teamSharing.kindAnalysis': 'Analisi',
  'filter.teamSharing.filterAccess': 'Filtra per permesso di accesso',
  'filter.teamSharing.accessRead': 'Sola lettura',
  'filter.teamSharing.accessWrite': 'Lettura e scrittura',
  'filter.teamSharing.exampleSessionTrack': 'Sessioni condivise di Lonato',
  'filter.teamSharing.exampleAnalysisWrite': 'Analisi condivise modificabili',

  'filter.drivers.bareSearchExample': 'Cerca per nome pilota, team, categoria o materiale',
  'filter.drivers.searchName': 'Filtra per nome pilota',
  'filter.drivers.searchCountry': 'Filtra per codice nazionalità',
  'filter.drivers.searchTeam': 'Filtra per team',
  'filter.drivers.searchCategory': 'Filtra per categoria',
  'filter.drivers.searchChassis': 'Filtra per marca telaio',
  'filter.drivers.searchEngine': 'Filtra per marca motore',
  'filter.drivers.filterEntries': 'Filtra per numero di partecipazioni',
  'filter.drivers.exampleCountryEntries': 'Piloti italiani con 5+ partecipazioni',
  'filter.drivers.exampleCatTeam': 'Piloti Mini di uno specifico team',

  'filter.driverHistory.bareSearchExample': 'Cerca per stagione, evento, tracciato o categoria',
  'filter.driverHistory.searchSeason': 'Filtra per stagione di campionato',
  'filter.driverHistory.searchEvent': 'Filtra per nome evento',
  'filter.driverHistory.searchTrack': 'Filtra per nome circuito',
  'filter.driverHistory.searchCategory': 'Filtra per categoria',
  'filter.driverHistory.searchTeam': 'Filtra per nome team',
  'filter.driverHistory.filterPos': 'Filtra per posizione finale',
  'filter.driverHistory.filterGrid': 'Filtra per posizione in griglia',
  'filter.driverHistory.filterPoints': 'Filtra per punti ottenuti',
  'filter.driverHistory.filterBestLap': 'Filtra per giro veloce (secondi)',
  'filter.driverHistory.filterPenalties': 'Filtra per numero di penalità',
  'filter.driverHistory.examplePodiums': 'Piazzamenti a podio (Top 3)',
  'filter.driverHistory.examplePointsPenalty': 'Eventi ad alto punteggio senza penalità',

  // Additional Analysis & Component Keys
  'braking.colSelect': 'Sel',
  'braking.colCompare': 'Cfr',
  'braking.scoreUnit': '/ 100',
  'braking.trackOverview': 'Panoramica tracciato',
  'braking.cornersCount': '{count} curve',
  'braking.trackAnalysis': 'Analisi frenata del tracciato',
  'braking.lapsTotal': '{count} giri totali',
  'braking.sample': 'Campione',
  'lapdiff.pointDetail': 'Dettaglio punto',
  'lapdiff.selectTwoLaps': 'Seleziona 2 giri',
  'lapdiff.lapTime': 'Tempo sul giro',
  'aggregationdiff.toggleLayers': 'Mostra/nascondi livelli mappa',
  'aggregationdiff.leftInner': 'Sinistra (Interno)',
  'aggregationdiff.rightOuter': 'Destra (Esterno)',
  'aggregationdiff.selectLap': 'Seleziona un giro',
  'aggregationdiff.modeSingleLap': 'Giro singolo',
  'aggregationdiff.modeSessions': 'Sessioni',
  'braking.phaseBraking': 'Frenata',
  'braking.phaseAccel': 'Accelerazione',
  'setup.tabFront': 'Anteriore',
  'setup.tabRear': 'Posteriore',
  'team.you': 'Tu',
  'races.entries': 'Iscritti',
  // Filter Schema & UI Translations
  'filter.filterBy': 'Filtra per {label}',
  'filter.removeFilter': 'Rimuovi filtro {label}',
  'filter.prevMonth': 'Mese precedente',
  'filter.nextMonth': 'Mese successivo',
  'filter.selectStartDate': 'Seleziona la data di inizio nel calendario',
  'filter.op.exact': 'Esatto',
  'filter.op.atLeast': 'Almeno',
  'filter.op.atMost': 'Al massimo',
  'filter.op.between': 'Tra',
  'filter.op.greater': 'Maggiore',
  'filter.op.less': 'Minore',
  'filter.preset.today': 'Oggi',
  'filter.preset.last7d': 'Ultimi 7 giorni',
  'filter.preset.last30d': 'Ultimi 30 giorni',
  'filter.preset.last90d': 'Ultimi 90 giorni',
  'filter.preset.last1y': 'Ultimo anno',
  'filter.preset.last7dShort': 'Ultimi 7g',
  'filter.preset.last30dShort': 'Ultimi 30g',
  'filter.preset.last90dShort': 'Ultimi 90g',
  'filter.preset.last1yShort': 'Ultimo 1a',
  'filter.sessionType.race': 'Gara',
  'filter.sessionType.final': 'Finale',
  'filter.sessionType.pre_final': 'Prefinale',
  'filter.sessionType.heat': 'Manche',
  'filter.sessionType.qualifying': 'Qualifiche',
  'filter.unit.laps': 'giri',
  'filter.schema.tyres.title': 'Sintassi di ricerca pneumatici',
  'filter.schema.tyres.subtitle': 'Filtra gli pneumatici per marca, mescola, utilizzo, codice a barre, pista o stato smaltito.',
  'filter.field.brand': 'Marca',
  'filter.desc.brand': 'Produttore di pneumatici (Mojo, Vega, LeCont, Bridgestone, ecc.)',
  'filter.field.tyreModel': 'Modello pneumatico',
  'filter.placeholder.tyreModel': 'es. D2, D5, W5, CIK Option',
  'filter.desc.tyreModel': 'Nome del modello o specifica della mescola',
  'filter.field.compound': 'Mescola',
  'filter.desc.compound': 'Categoria mescola (asciutto, bagnato, slick, pioggia)',
  'filter.compound.dry': 'Asciutto',
  'filter.compound.wet': 'Bagnato',
  'filter.compound.slick': 'Slick',
  'filter.compound.rain': 'Pioggia',
  'filter.field.setNumber': 'Numero set',
  'filter.desc.setNumber': 'Numero del set di pneumatici assegnato nell’inventario',
  'filter.field.totalLaps': 'Giri totali',
  'filter.desc.totalLaps': 'Totale cumulativo dei giri percorsi con questo set di pneumatici',
  'filter.preset.tyreFresh': 'Fresco (0..15 giri)',
  'filter.preset.tyreBrokenIn': 'Rodato (16..50 giri)',
  'filter.preset.tyreHighMileage': 'Alto chilometraggio (> 50 giri)',
  'filter.field.barcode': 'Codice a barre',
  'filter.placeholder.barcode': 'Codice a barre AS, AD, PS, PD',
  'filter.desc.barcode': 'Corrispondenza parziale su qualsiasi codice a barre del set',
  'filter.field.lastTrack': 'Ultima pista',
  'filter.desc.lastTrack': 'Ultima pista in cui è stato utilizzato questo set di pneumatici',
  'filter.field.discarded': 'Smaltiti',
  'filter.desc.discarded': 'Indica se il set di pneumatici è stato contrassegnato come smaltito',
  'filter.discarded.false': 'No',
  'filter.discarded.true': 'Sì',
  'filter.example.activeTyres': 'Set di pneumatici attivi (non smaltiti)',
  'filter.example.dryMojo': 'Pneumatici da asciutto Mojo',
  'filter.example.highMileage70': 'Set di pneumatici con oltre 70 giri',
  'filter.example.freshTyres': 'Pneumatici freschi / basso chilometraggio',
  'filter.example.lonatoTyres': 'Pneumatici usati a Lonato da agosto 2026',
  'filter.example.vegaOrWet': 'Set Vega o qualsiasi pneumatico da bagnato',
  'filter.field.date': 'Data',
  'filter.desc.date': 'Filtra per periodo relativo (-7d, -30d, today) o intervallo di date del calendario',
  'filter.field.track': 'Pista',
  'filter.desc.track': 'Corrisponde al nome della pista',
  'filter.placeholder.track': 'es. Wohlen, Lonato',
  'filter.field.driver': 'Pilota',
  'filter.desc.driver': 'Corrisponde al nome del pilota',
  'filter.placeholder.driver': 'es. Yanick',
  'filter.field.season': 'Stagione',
  'filter.desc.season': 'Corrisponde all’anno della stagione',
  'filter.field.category': 'Categoria',
  'filter.desc.category': 'Categoria di gara canonica',
  'filter.field.championship': 'Campionato',
  'filter.desc.championship': 'Nome del campionato',
  'filter.field.sessionType': 'Tipo di sessione',
  'filter.desc.sessionType': 'Classificazione sessione (gara, manche, qualifiche, finale)',
  'filter.field.position': 'Posizione',
  'filter.field.finishPosition': 'Posizione finale',
  'filter.desc.position': 'Posizione d’arrivo (es. position:<=3 per i podi)',
  'filter.preset.posWinner': 'Vincitore (P1)',
  'filter.preset.posPodium': 'Podio (≤ P3)',
  'filter.preset.posTop5': 'Top 5 (≤ P5)',
  'filter.preset.posTop10': 'Top 10 (≤ P10)',
  'filter.field.temp': 'Temperatura',
  'filter.desc.temp': 'Temperatura ambiente della sessione in gradi Celsius (es. temp:15..25)',
  'filter.preset.tempCool': 'Fresco (< 15°C)',
  'filter.preset.tempMild': 'Mite (15..25°C)',
  'filter.preset.tempWarm': 'Caldo (≥ 25°C)',
  'filter.field.laps': 'Giri',
  'filter.desc.laps': 'Corrisponde al numero di giri completati (es. laps:>=5, laps:5..20)',
  'filter.preset.lapsShort': 'Breve (≤ 5 giri)',
  'filter.preset.lapsMedium': 'Media (6..15 giri)',
  'filter.preset.lapsLong': 'Lunga (> 15 giri)',
  'analysis.sector': 'Analisi settori',
  'analysis.corner': 'Velocità in curva',
  'analysis.braking': 'Analisi frenata',
  'analysis.lapdiff': 'Confronto giri',
  'analysis.aggregation': 'Aggregazione',
  'analysis.aggregationdiff': 'Confronto aggregazione',
  'filter.schema.analyses.title': 'Sintassi di ricerca analisi',
  'filter.schema.analyses.subtitle': 'Filtra la cronologia delle analisi con chiavi strutturate o parole chiave.',
  'filter.field.nameTrack': 'Nome / Pista',
  'filter.placeholder.nameTrack': 'es. Sarno, Run personalizzato',
  'filter.desc.nameTrack': 'Corrisponde al nome dell’analisi o della pista (corrispondenza parziale)',
  'filter.field.toolType': 'Tipo di strumento',
  'filter.placeholder.toolType': 'es. sector, corner, lapdiff, aggregation, aggregationdiff',
  'filter.desc.toolType': 'Filtra per tipo di analisi (sector, corner, lapdiff, aggregation, aggregationdiff)',
  'filter.example.sarnoSector': 'Analisi dei settori a Sarno',
  'filter.example.lapdiff30d': 'Confronti giri degli ultimi 30 giorni',
  'filter.example.wohlenCorner': 'Analisi in curva a Wohlen o Mirecourt',
  'filter.schema.sessions.title': 'Sintassi di ricerca sessioni',
  'filter.schema.sessions.subtitle': 'Filtra le sessioni usando chiavi strutturate o parole chiave.',
  'filter.field.trackDriver': 'Pista / Pilota',
  'filter.placeholder.trackDriver': 'es. Wohlen, Mirecourt',
  'filter.desc.trackDriver': 'Corrisponde al nome della pista o del pilota (corrispondenza parziale)',
  'filter.schema.driverHistory.title': 'Sintassi di ricerca storico pilota',
  'filter.schema.driverHistory.subtitle': 'Filtra lo storico gare per pista, campionato, categoria, tipo di sessione, posizione o stagione.',
  'filter.example.podiumWohlen': 'Podi a Wohlen',
  'filter.example.dd2Races2026': 'Gare DD2 del 2026',
  'filter.example.victoriesLast1y': 'Vittorie nell’ultimo anno',
  'filter.schema.driversList.title': 'Sintassi di ricerca piloti',
  'filter.schema.driversList.subtitle': 'Filtra i piloti per nome, stagione attiva, categoria o data di partecipazione.',
  'filter.field.driverName': 'Nome pilota',
  'filter.placeholder.driverName': 'es. Yanick, Senn',
  'filter.desc.driverName': 'Corrisponde al nome o cognome del pilota',
  'filter.example.findDriverYanick': 'Trova i piloti corrispondenti a Yanick',
  'filter.example.activeDd22026': 'Piloti DD2 attivi nel 2026',
  'filter.example.driversLast90d': 'Piloti che hanno gareggiato negli ultimi 90 giorni',
  'filter.schema.teamMembers.title': 'Sintassi di ricerca membri del team',
  'filter.schema.teamMembers.subtitle': 'Filtra i membri del team per nome, ruolo o email.',
  'filter.field.memberName': 'Nome membro',
  'filter.placeholder.memberName': 'es. Yanick, Alice',
  'filter.desc.memberName': 'Corrisponde al nome visualizzato del membro',
  'filter.field.role': 'Ruolo',
  'filter.desc.role': 'Livello di autorizzazione (admin, gestisci, lettura)',
  'team.role.admin': 'Admin',
  'filter.field.email': 'Email',
  'filter.placeholder.email': 'es. gmail.com',
  'filter.desc.email': 'Corrisponde all’indirizzo email',
  'filter.example.findMemberYanick': 'Trova i membri corrispondenti a Yanick',
  'filter.example.findTeamAdmins': 'Trova gli amministratori del team',
  'filter.example.findTeamManage': 'Trova i membri con permessi di gestione',
  'filter.schema.teamSharing.title': 'Sintassi di ricerca condivisioni team',
  'filter.schema.teamSharing.subtitle': 'Filtra gli accessi condivisi per proprietario, tipo di condivisione o livello di permesso.',
  'filter.field.ownerName': 'Proprietario / Nome',
  'filter.desc.ownerName': 'Corrisponde al nome del proprietario',
  'filter.field.shareScope': 'Ambito condivisione',
  'filter.desc.shareScope': 'Tipo di ambito di condivisione (tutti i dati, sessione singola, pista specifica)',
  'filter.shareScope.all': 'Tutta la telemetria',
  'filter.shareScope.single': 'Sessione singola',
  'filter.shareScope.track': 'Pista specifica',
  'filter.example.sharesYanick': 'Trova le condivisioni di Yanick',
  'filter.example.sharesAllRead': 'Condivisioni complete di telemetria in sola lettura',
  'filter.schema.trackLeaderboard.title': 'Sintassi di ricerca classifica pista',
  'filter.schema.trackLeaderboard.subtitle': 'Filtra i giri e le sessioni in classifica per pilota, stagione, categoria, posizione o temperatura.',
  'filter.example.yanickFastest2026': 'Giri più veloci di Yanick nella stagione 2026',
  'filter.example.podiumSeniorMax': 'Podi in Senior MAX',
  'filter.example.warm90d': 'Sessioni con clima caldo negli ultimi 90 giorni',
  'filter.schema.trackRaceEvents.title': 'Sintassi di ricerca eventi di gara',
  'filter.schema.trackRaceEvents.subtitle': 'Filtra gli eventi di gara per stagione, campionato, categoria o pilota partecipante.',
  'filter.desc.driverEvent': 'Corrisponde a un pilota partecipante all’evento',
  'filter.example.rmc2026': 'Eventi RMC Switzerland 2026',
  'filter.example.yanick2025': 'Eventi a cui ha partecipato Yanick nel 2025',
  'filter.example.dd2Last1y': 'Eventi DD2 nell’ultimo anno',
  'filter.schema.tracks.title': 'Sintassi di ricerca piste',
  'filter.schema.tracks.subtitle': 'Filtra le piste per nome o parole chiave.',
  'filter.field.trackName': 'Nome pista',
  'filter.example.findWohlen': 'Trova le piste corrispondenti a Wohlen',
  'filter.example.exactTrack': 'Corrispondenza esatta del nome pista',
};
